// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/assets/action/icon_release.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../public/assets/action/check_outline.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../public/assets/button/icon_restore.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../public/assets/action/icon_merge.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../public/assets/menu.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../public/assets/button/icon_dashboard.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../public/assets/button/icon_grid_row.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../public/assets/action/icon_delete.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../public/assets/action/icon_delete_white.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../public/assets/action/icon_discard.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../public/assets/magic_wand_default.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../public/assets/cloudy_export.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../public/assets/sunny_export.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../public/assets/snowy_export.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../public/assets/heavy_rain_export.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../public/assets/icon_right_arrow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../public/assets/icon_left_arrow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../public/assets/icon_total_hours_hover.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../public/assets/icon_billable_hours_hover.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../public/assets/expand_default.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../public/assets/expand_hover.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../public/assets/minimize_default.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../public/assets/minimize_hover.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../public/assets/close_dialog.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../public/assets/help_page_hover_close.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../public/assets/trashcan_icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../public/assets/keep_default.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("../public/assets/keep_hover.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("../public/assets/headset_default.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("../public/assets/headset_hover.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("../public/assets/arrow_up_hover.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("../public/assets/collapsed_hover.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("../public/assets/search_matter_check.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("../public/assets/search_matter_check_hover.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("../public/assets/search_matter_close.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("../public/assets/search_matter_close_hover.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("../public/assets/open-slot-stripe.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_37___ = new URL("../public/assets/common/ai_generated.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_38___ = new URL("../public/assets/common/ai_generated_white.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_39___ = new URL("../public/assets/common/ai_check.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_40___ = new URL("../public/assets/common/ai_check_white.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_41___ = new URL("../public/assets/common/ai_close.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_42___ = new URL("../public/assets/common/ai_close_white.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_43___ = new URL("../public/assets/maintenance_bg.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___);
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___);
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_38___);
var ___CSS_LOADER_URL_REPLACEMENT_39___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_39___);
var ___CSS_LOADER_URL_REPLACEMENT_40___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_40___);
var ___CSS_LOADER_URL_REPLACEMENT_41___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_41___);
var ___CSS_LOADER_URL_REPLACEMENT_42___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_42___);
var ___CSS_LOADER_URL_REPLACEMENT_43___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_43___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  overflow: hidden;
  margin: 0;
}

@-webkit-keyframes spin {
  from {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}

@keyframes spin {
  from {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}

.css-95 {
  padding: 0 0 0 20px;
}

.text-hover {
  color: #865bdf;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
}

.text-hover:hover {
  text-decoration: underline;
}

.text-link {
  color: #0d81d5;
  font-size: 12px;
  font-weight: 400;
  text-decoration-line: underline;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 5px;
}

.btn-text-active {
  font-size: 14px;
  height: 30px;
  line-height: 30px;
  border-radius: 30px;
  border: 1px solid #d9d9d9;
  background: #865bdf;
  border-color: #865bdf;
  color: #fff;
  display: inline-block;
  vertical-align: top;
  padding: 0px 12px;
  cursor: pointer;
}

.btn-disabled {
  background: #999;
  color: #fff;
  border: 1px solid #999;
  cursor: not-allowed;
  pointer-events: none;
}

.btn-text-inactive {
  font-size: 14px;
  height: 30px;
  line-height: 30px;
  border-radius: 30px;
  border: 1px solid #d9d9d9;
  color: #333;
  display: inline-block;
  vertical-align: top;
  padding: 0px 12px;
  cursor: pointer;
}

.btn-text-inactive:hover {
  background: #f2f4ff;
}

.option-text-active {
  height: 22px;
  line-height: 22px;
  border-radius: 4px;
  border: 1px solid #865bdf;
  background: #865bdf;
  -webkit-box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
          box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
  color: #fff;
  padding: 0px 10px;
  font-size: 12px;
  font-weight: 400;
  cursor: pointer;
}

.option-text-inactive {
  height: 22px;
  line-height: 22px;
  border-radius: 4px;
  -webkit-box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
          box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
  color: #333;
  padding: 0px 10px;
  font-size: 12px;
  font-weight: 400;
  cursor: pointer;
  border: 1px solid #fff;
}

.option-text-inactive:hover {
  border: 1px solid #865bdf;
  background: #ede6fa;
  -webkit-box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
          box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
  color: #865bdf;
}

.btn-action {
  font-size: 14px;
  height: 30px;
  line-height: 30px;
  border-radius: 30px;
  border: 1px solid #dadada;
  background: #fff;
  color: #333;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 4px;
  vertical-align: top;
  padding: 0px 12px;
  cursor: pointer;
  white-space: nowrap;
}

.btn-action:hover {
  background: #d9d9d9;
  border-color: #d9d9d9;
}

.btn-action:disabled {
  background: #999;
  color: #fff;
  cursor: not-allowed;
  border: 1px solid #999;
}

.btn-action-disabled {
  font-size: 14px;
  cursor: not-allowed;
  height: 30px;
  line-height: 30px;
  border-radius: 30px;
  background: #999;
  color: #fff;
  vertical-align: top;
  padding: 0px 12px;
  border: 1px solid #999;
}

.btn-action img,
.btn-action-disabled img {
  width: 16px;
}

.btn-more {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  min-height: 24px;
  min-width: 16px;
  padding: 0;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 4px;
}

.btn-more-mobile {
  margin-right: 6px;
}

.btn-status:hover .btn-status-count {
  background: #5e409c;
}

.btn-release img {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.btn-accept-release img {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.btn-restore img {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.btn-merge img {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.btn-close-panel,
.btn-expand-panel {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  padding: 6px;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 10px;
  border-radius: 5px;
  background: #fff;
  -webkit-box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);
          box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);
}

.btn-close-panel:hover,
.btn-expand-panel:hover {
  background: #d9d9d9;
}

.btn-expand-panel img {
  width: 16px;
  height: 16px;
  content: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.btn-dashboard img {
  width: 16px;
  height: 16px;
  content: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

.btn-grid img {
  width: 16px;
  height: 16px;
  content: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

.btn-close-panel img {
  width: 16px;
  height: 16px;
  content: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.btn-action-delete img {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

.btn-action-delete-disabled {
  background: #999999 !important;
  color: #fff;
  cursor: not-allowed;
  border: none !important;
}

.btn-action-delete-disabled img {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

.btn-action-discard img {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}

.btn-delete {
  border-radius: 40px;
  border: 1px solid #ff444b;
  background: #ff444b;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: 30px;
  height: 30px;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 10px;
}

.btn-delete:hover {
  border: 1px solid #e60022;
  background: #e60022;
}

.btn-delete:disabled {
  border: 1px solid #999;
  background: #999;
}

.btn-image {
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  border-radius: 50%;
  border: 1px solid #dadada;
  background: #fff;
  color: #333;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: 30px;
  height: 30px;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 10px;
  -ms-flex-negative: 0;
      flex-shrink: 0;
}

.btn-image:hover {
  border: 1px solid #d9d9d9;
  background: #d9d9d9;
}

.btn-image:disabled {
  color: #fff;
  border: 1px solid #999;
  background: #999;
}

.btn-magic {
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 1px solid #dadada;
  background: #fff;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  cursor: pointer;
}

.btn-magic:hover {
  background: #d9d9d9;
}

.magic {
  width: 17px;
  height: 17px;
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}

.btn-return {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  color: #865bdf;
  font-size: 14px;
  -webkit-box-pack: end;
      -ms-flex-pack: end;
          justify-content: flex-end;
  font-weight: 400;
  background: transparent;
  text-decoration-line: underline;
  cursor: pointer;
}

.dashboard-weather-icon {
  margin-top: 20px;
  margin-left: 5%;
  padding: 0;
  border: none;
  float: left;
  background-repeat: no-repeat;
  background-position: center;
  width: 100px;
  height: 100px;
}

.dashboard-weather-clouds {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}

.dashboard-weather-clear {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}

.dashboard-weather-snow {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
}

.dashboard-weather-rain {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
}

.highlight-column {
  cursor: pointer;
  /* background-color: #fff; */
}

.select-container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  padding: 8px;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  height: calc(100% - 10px);
  gap: 4px;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  color: #333;
  font-size: 24px;
  font-weight: 500;
}

.summary-container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  gap: 12px;
}

.summary-day {
  color: #865bdf;
  text-align: center;
  font-size: 24px;
  font-style: normal;
  font-weight: 510;
  line-height: 34px;
}

.summary-hr-container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  padding: 12px 8px;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  gap: 8px;
  color: #333;
  font-size: 24px;
  font-weight: 500;
  border-radius: 4px;
  background: #fff;
  -webkit-box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.11);
          box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.11);
}

.summary-hr-container:hover {
  background: #f2f4ff;
  /* Component/Small Component */
  -webkit-box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.11);
          box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.11);
}

.summary-hr-container:active {
  border: 2px solid #865bdf;
}

.summary-hr {
  color: #333;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
}

.m-icon-right-arrow {
  width: 24px;
  height: 24px;
  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
}

.m-icon-left-arrow {
  width: 24px;
  height: 24px;
  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
}

.week-option-selected {
  position: relative;
  color: #865bdf !important;
  background: #fff;
}

.week-option-selected .selected-border {
  height: 3px;
  width: 100%;
  border-radius: 1px;
  background: #865bdf;
  position: absolute;
  bottom: 0px;
  left: 0;
}

.week-row {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 4px;
}
.week-option {
  color: #999;
  padding: 4px 0;
  height: 100%;
}

.week-option:hover {
  color: #865bdf;
}

.week-option:hover .week-hour .total-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
}
.week-option:hover .week-hour .billable-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
}
.week-title {
  cursor: pointer;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  border-radius: 4px;
  min-width: 72px;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  min-height: 32px;
  padding: 2px 0px 4px 0px;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 4px;
  font-size: 16px;
  font-weight: 400;
  position: relative;
}
.week-title:hover {
  background: #f1f0f2 !important;
}

.week-title-selected {
  background: transparent !important;
}
.week-title-selected:hover {
  background: transparent !important;
}

.divider-line {
  width: 1px;
  height: 14px;
  background: #d8d8d8;
  margin: 0 4px;
}

.page-description {
  color: #333;
  font-size: 14px;
  font-weight: 400;
}

.border-circle {
  width: 4px;
  height: 4px;
  border-radius: 2px;
  background: #dadada;
  margin: auto 8px;
  display: inline-block;
  vertical-align: middle;
}

.fixed-header {
  padding: 0 0 12px;
  z-index: 2000;
  position: sticky;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  background-color: #fff;
}

.grid-wrapper {
  /* height: calc(100vh - 180px); */
  min-height: 400px;
  overflow-y: auto;
  /* —— 隐藏滚动条 —— */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE/Edge legacy */
}

.grid-wrapper::-webkit-scrollbar {
  display: none; /* Chrome/Safari */
}

.k-grid-header {
  position: sticky;
  top: 0;
  background: white;
  z-index: 10;
}

.css-59 {
  padding: 0px 20px !important;
}

.greeting-container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  margin-bottom: 10px;
  color: #fff;
  background-color: #865bdf;
  border-radius: 5px;
  /* height: 88px; */
  -webkit-box-flex: 1;
      -ms-flex: 1;
          flex: 1;
}

.tooltip-content {
  background-color: #fff;
  color: #956fe3;
  font-size: 12px;
  font-weight: 600;
  padding: 15px;
  width: 190px;
}

.tooltip-contact {
  border-radius: 4px;
  background: #fff;
  -webkit-box-shadow: 1px 1px 4px 0px rgba(0, 0, 0, 0.1);
          box-shadow: 1px 1px 4px 0px rgba(0, 0, 0, 0.1);
  color: #010101;
  font-size: 12px;
  font-weight: 300;
}

.expand-icon {
  width: 14px;
  height: 14px;
  background-size: 14px 14px;
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
}

.expand-icon:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
}

.minimize-icon {
  width: 14px;
  height: 14px;
  background-size: 14px 14px;
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
}

.minimize-icon:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
}

.close-icon {
  width: 14px;
  height: 14px;
  background-size: 14px 14px;
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
}

.close-icon:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
}

.trashcan-icon {
  width: 16px;
  height: 16px;
  background-size: 16px 16px;
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
}

.setting-option {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  padding: 7px 14px;
}

.setting-option:hover {
  background: #f9f9f9;
}

.btn-keep {
  width: 61px;
  height: 30px;
  background-size: 61px 30px;
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
}

.btn-keep:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
}

.btn-discard {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  height: 26px;
  padding: 0 10px;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  border-radius: 34px;
  border: 1px solid #dadada;
  background: #fff;
  cursor: pointer;
}

.btn-discard img {
  width: 16px;
  height: 16px;
}

.btn-discard span {
  font-size: 12px;
  color: #999;
  font-weight: 400;
}

.btn-accept {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  height: 26px;
  padding: 0 10px;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  border-radius: 34px;
  border: 1px solid #865bdf;
  background: #865bdf;
  cursor: pointer;
}

.btn-accept img {
  width: 16px;
  height: 16px;
}

.btn-accept span {
  font-size: 12px;
  color: #fff;
  font-weight: 400;
}

@media (min-width: 768px) {
  .btn-accept,
  .btn-discard {
    height: 30px;
    padding: 0 12px;
    border-radius: 40px;
  }

  .btn-discard img,
  .btn-accept img {
    width: 19px;
    height: 19px;
  }

  .btn-discard span,
  .btn-accept span {
    font-size: 14px;
  }
}

.show {
  display: block;
}

.loader-center {
  position: absolute;
  z-index: 2;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
}

.account-body {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  height: 100vh;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}

.text-highlight {
  color: #0d81d5;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.text-highlight:hover {
  text-decoration-line: underline;
}

.btn-help-center {
  border-radius: 4px;
  border: 1px solid #865bdf;
  padding: 6px 28px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  gap: 5px;
  color: #865bdf;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  margin-top: 15px;
}

.help-center-img {
  width: 24px;
  height: 24px;
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
}

.btn-help-center:hover {
  border: 1px solid #865bdf;
  background: #865bdf;
  color: #fff;
}

.btn-help-center:hover .help-center-img {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_29___});
}

.required-error {
  border: 1px solid red !important;
  border-radius: 5px;
  min-height: 40px !important;
}

.disabled-row {
  background-color: #f5f5f5 !important;
  color: #999 !important;
  pointer-events: none; /* 禁止交互 */
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
  font-size: 14px;
}

.parent-row {
  background-color: #f2f4ff !important;
  border-bottom: 1px solid #fff;
  font-size: 14px;
}

.parent-row:hover {
  background-color: #f2f4ff !important;
}

.child-row {
  position: relative;
  /* z-index: 10000; */
  background: #fbfcfe;
}

/* 适用于子项行的所有 cell */
.k-table-row.child-row td {
  font-size: 12px !important;
}

/* 如果里面还有 span、div 之类，也可以追加一层 */
.k-table-row.child-row td span,
.k-table-row.child-row td div {
  font-size: 12px !important;
}

.k-table-row.child-row td .fontSize-10 {
  font-size: 10px !important;
}

.k-table-row.child-row td .text-color-gray {
  font-size: 10px !important;
}

.child-row:not(.last-child-row)::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: -1px;
  height: 1px;
  background-color: #f2f4ff;
  z-index: -1;
}

.last-child-row {
  position: relative;
  /* z-index: 10000;  */
}

.last-child-row::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: -2px; /* 控制阴影显示到行外 */
  height: 2px;
  -webkit-box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.06);
          box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.06);
  background: transparent;
  z-index: -1; /* 放在 row 背后 */
}

.orphan-row {
  background-color: #fff !important;
  font-size: 14px;
}

.toggle-icon img {
  width: 16px;
  height: 16px;
  -webkit-transition: 0.2s ease;
  transition: 0.2s ease;
}

/* hover 替换图片：使用 content swap via background-image 是不行的，必须 JS 或用 attr src 替换 */
/* 所以我们用伪类控制背景图，只改变 \`src\` 替代方案见下面 advanced */
.toggle-icon[data-expanded='true']:hover img {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_30___});
}

.toggle-icon[data-expanded='false']:hover img {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_31___});
}

/* 自定义整体按钮样式 */
.custom-split-button.k-split-button {
  height: 32px;
  -webkit-box-shadow: none;
          box-shadow: none;
}
.custom-split-button.k-button-group > .k-button:first-child:not(:only-child) {
  border-radius: 40px 0px 0px 40px;
  border: 1px solid #dadada;
  background: #fff;
  font-size: 14px;
}

.custom-split-button.k-button-group
  > .k-button:first-child:not(:only-child):hover {
  background: #d9d9d9;
}

.custom-split-button.k-button-group > .k-button:last-child:not(:only-child) {
  border-radius: 0px 40px 40px 0px;
  background: #fff;
  border: 1px solid #dadada;
  font-size: 14px;
}

.custom-split-button.k-button-group
  > .k-button:last-child:not(:only-child):hover {
  background: #d9d9d9;
}

/* 自定义分隔线颜色（按钮和下拉箭头之间） */
.custom-split-button .k-split-button-arrow {
  border-left: 1px solid rgba(255, 255, 255, 0.3);
}

.custom-split-button + .k-animation-container .k-popup {
  -webkit-box-shadow: none !important;
          box-shadow: none !important;
}

/* 自定义整体按钮样式 */
.primary-split-button.k-split-button {
  height: 32px;
  -webkit-box-shadow: none;
          box-shadow: none;
}
.primary-split-button.k-button-group > .k-button:first-child:not(:only-child) {
  border-radius: 40px 0px 0px 40px;
  border: none;
  background: #333;
  padding: 0px 12px;
  color: #fff;
  font-size: 14px;
  border-right: 1px solid #fff;
  line-height: 20px;
}

.primary-split-button.k-button-group
  > .k-button:first-child:not(:only-child):hover {
  background: #000000;
}

.primary-split-button.k-button-group > .k-button:last-child:not(:only-child) {
  border-radius: 0px 40px 40px 0px;
  background: #333;
  border: none;
  color: #fff;
  font-size: 14px;
  padding: 0 16px 0 12px;
  border-left: 1px solid #fff;
}

.primary-split-button.k-button-group
  > .k-button:last-child:not(:only-child):hover {
  background: #000000;
}

/* 自定义分隔线颜色（按钮和下拉箭头之间） */
.primary-split-button .k-split-button-arrow {
  border-left: 1px solid #fff;
}

.primary-split-button + .k-animation-container .k-popup {
  -webkit-box-shadow: none !important;
          box-shadow: none !important;
}

.primary-split-button .k-button:disabled,
.primary-split-button .k-button.k-disabled {
  background: #999 !important;
}

.custom-multi-select-item {
  background: #fff !important;
}

.custom-multi-select-item:hover {
  background: #f2f4ff !important;
}

.k-child-animation-container .k-menu-item .k-menu-link {
  border-radius: 4px;
  background: #fff;
  -webkit-box-shadow: 0px 1.973px 9.867px 0px rgba(0, 0, 0, 0.2);
          box-shadow: 0px 1.973px 9.867px 0px rgba(0, 0, 0, 0.2);
  padding: 10px;
  color: #333;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px; /* 157.143% */
}

.k-child-animation-container .k-menu-item .k-menu-link:hover {
  background: #f2f4ff !important;
}

.k-child-animation-container .k-menu-item .k-menu-link {
  border: none !important;
  -webkit-box-shadow: none !important;
          box-shadow: none !important;
}

.menu-item:hover {
  background: #f5f5f5;
}

.client-row {
  color: #333;
  font-size: 14px;
  font-weight: 600;
  background: #f7f8fc;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  cursor: pointer;
  padding: 4px 8px 4px 20px;
}

.matter-row {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  padding: 4px 8px 4px 20px;
  color: #595959;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  background: #fff;
}

.k-tooltip.custom-tooltip {
  z-index: 200000 !important; /* 高于 window 的遮罩 */
}

.hiddenScroll {
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE 10+ */
}
.hiddenScroll::-webkit-scrollbar {
  width: 0;
  height: 0;
}
.hiddenScroll ::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.mobile-timeline-scroll-container,
.mobile-timeline-scroll-container .k-listview-content {
  -webkit-overflow-scrolling: touch;
  overscroll-behavior-y: contain;
  -ms-touch-action: pan-y;
      touch-action: pan-y;
}

.fixed-child-height {
  height: 50px;
}

.save-button {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  padding: 5px 12px;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 4px;
  background-color: #333;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  color: #fff;
  border-radius: 30px;
  border: 1px solid #dadada;
  cursor: pointer;
}

.save-button:hover {
  background: #000000;
}

.cancel-button,
.release-button {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  padding: 5px 12px;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 4px;
  color: #333;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  background-color: #fff;
  border-radius: 30px;
  border: 1px solid #dadada;
  cursor: pointer;
}

.cancel-button:hover,
.release-button:hover {
  background: #f5f5f5;
}

.confirm-button {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  padding: 5px 12px;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 4px;
  color: #fff;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  border-radius: 30px;
  cursor: pointer;
}

@media (max-width: 767px) {
  .confirm-button {
    padding-top: 14px;
    padding-bottom: 14px;
  }
}

.primary-button {
  background-color: #333;
  border: 1px solid #333;
}

.primary-button:hover {
  border: 1px solid #000000;
  background: #000000;
}

.primary-button:disabled {
  background: #999;
  color: #fff;
  cursor: not-allowed;
  border: 1px solid #999;
}

.input-error {
  border-color: #b3261e !important;
}

.ocg-field-warning,
.ocg-field-warning .k-input,
.ocg-field-warning .k-input-solid {
  background-color: #fff3e0 !important;
  border-color: #ffa007 !important;
}

.error-text {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  gap: 5px;
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: start;
  color: #b3261e;
  font-size: 14px;
  font-weight: 400;
  margin-top: 4px;
}

.now-button {
  background: #fff;
  margin-bottom: 2px;
  padding: 2px 8px;
  font-size: 12px;
  font-weight: 600;
  border-radius: 11px;
  border: 1px solid #865bdf;
  color: #865bdf;
  cursor: pointer;
}

.now-button:hover {
  border: 1px solid #865bdf;
  background: #865bdf;
  color: #fff;
}

.new-now-button {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: 44px;
  height: 24px;
  padding: 0 9px;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 10px;
  background: #fff;
  font-size: 12px;
  font-weight: 400;
  border-radius: 11px;
  border: 1px solid #d9d9d9;
  color: #333;
  cursor: pointer;
}

.new-now-button:hover {
  background: #d9d9d9;
}

.nav-item {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 10px;
  margin: 0 1rem 20px;
  padding: 20px 0 20px;
  color: #333;
  font-size: 14px;
  font-weight: 400;
}

.nav-item:hover {
  background: #eaecef;
}

.nav-item:active {
  background: #dadbdf;
}

.k-list-item {
  font-size: 14px;
}

.k-list-item.has-highlight {
  display: block !important;
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
  overflow: hidden;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
}

/* Search keyword highlight */
.highlighted-keyword {
  font-weight: 600;
  color: inherit;
  background: #fde047;
}

/* 当 hover 时改变颜色 */
/* .k-selected .highlighted-keyword,
.k-focus .highlighted-keyword {
  color: #ffffff!important;
  background: inherit!important;
} */

.settings-confirm-dialog {
  z-index: 1000001 !important;
  top: 50% !important;
  left: 50% !important;
  -webkit-transform: translate(-50%, -50%) !important;
          transform: translate(-50%, -50%) !important;
}

.settings-confirm-dialog .k-window {
  width: 480px;
  max-width: 80vw;
  border-radius: 20px;
}

.settings-confirm-dialog .k-window-actions {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: end;
      -ms-flex-pack: end;
          justify-content: flex-end;
  gap: 8px; /* 按钮之间间隔可选 */
  border-top: 1px solid #dadada;
}

.new-dialog .k-window {
  border-radius: 12px;
  border: none;
}

.dialog-wrapper-title {
  font-weight: 400;
  font-size: 20px;
  border-bottom: 1px solid #ddd;
  position: relative;
  background: -webkit-gradient(linear, left top, left bottom, from(#e4e1fc), to(#fff));
  background: linear-gradient(180deg, #e4e1fc 0%, #fff 100%);
  height: 160px;
}

@supports (-webkit-touch-callout: none) {
  input,
  textarea,
  select {
    font-size: 16px !important;
  }
}

.group-header-btn {
  border-radius: 40px;
  background: #fff;
  width: 30px;
  height: 30px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  color: #333;
  font-size: 14px;
  font-weight: 400;
  border: 1px solid #dadada;
}

.group-header-btn:hover {
  background: #dadada;
}

.group-highlight {
  background: #f6f0ff !important;
  -webkit-box-shadow: 0 0 0 3px #865bdf inset;
          box-shadow: 0 0 0 3px #865bdf inset;
}

.dragging-highlight {
  -webkit-box-shadow: 0 0 0 3px #7fb3ff inset !important;
          box-shadow: 0 0 0 3px #7fb3ff inset !important;
  background: #eef6ff !important;
}
.btn-slot {
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  width: 16px;
  height: 16px;
}

.btn-slot:hover {
  border-radius: 2px;
  background: rgba(0, 0, 0, 0.2);
}
.k-time-picker-sm {
  height: 30px;
}

.error-border {
  border: 1px solid #e25750;
  border-radius: 4px;
}

.editing-card {
  -webkit-box-shadow: 0 0 12px 0 rgba(255, 255, 255, 0.8) !important;
          box-shadow: 0 0 12px 0 rgba(255, 255, 255, 0.8) !important;
}

.grid-btn {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 4px;
  padding: 0 12px;
  height: 30px;
  border-radius: 40px;
  border: 1px solid #d9d9d9;
  background: #fff;
  color: #333;
  cursor: pointer;
  white-space: nowrap;
}

.grid-btn:hover {
  background-color: #f1f0f2;
}

.drag-hover-image {
  display: none;
}

.drag-card {
  background: #fff;
}

.drag-card:hover {
  background: #f1f0f2;
}

.drag-card:hover .drag-hover-image {
  display: block;
}

.btn-search-matter-check {
  width: 16px;
  height: 16px;
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_32___});
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  outline: none;
  -webkit-box-shadow: none;
          box-shadow: none;
}
.btn-search-matter-check:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_33___});
}
.btn-search-matter-close {
  width: 16px;
  height: 16px;
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  outline: none;
  -webkit-box-shadow: none;
          box-shadow: none;
}
.btn-search-matter-close:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
}
.scroll-container {
  overflow-x: auto;
  overflow-y: hidden;
}
.scroll-container::-webkit-scrollbar {
  height: 4px;
  width: 0px;
}
.scroll-container::-webkit-scrollbar-thumb {
  background-color: #d4c8eb;
  border-radius: 2px;
}
.scroll-container::-webkit-scrollbar-track {
  background: transparent;
}

.clickable-sysnotes:hover,
.clickable-sysnotes:active {
  text-decoration: underline;
}

.sysnotes-popup {
  border: none;
  -webkit-box-shadow: 0 1.973px 9.867px 0 rgba(0, 0, 0, 0.2);
          box-shadow: 0 1.973px 9.867px 0 rgba(0, 0, 0, 0.2);
}

.web-query-popup,
.web-query-popup.k-popup,
.k-animation-container.web-query-popup,
.k-animation-container.web-query-popup .k-child-animation-container,
.k-animation-container.web-query-popup .k-popup {
  border: none;
  background: transparent;
  -webkit-box-shadow: none;
          box-shadow: none;
  border-radius: 0;
  overflow: visible;
  padding: 0;
}

.web-query-card {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  max-width: 320px;
  max-height: 160px;
  overflow-y: auto;
  border-radius: 4px;
  background: #292929;
  padding: 8px 12px;
  color: #fff;
  -webkit-box-shadow: 0 1.973px 9.867px 0 rgba(0, 0, 0, 0.2);
          box-shadow: 0 1.973px 9.867px 0 rgba(0, 0, 0, 0.2);
}

.web-query-card::-webkit-scrollbar {
  width: 4px;
}

.web-query-card::-webkit-scrollbar-thumb {
  background: #666;
  border-radius: 100px;
}

.web-query-card .web-query-heading {
  -ms-flex-negative: 0;
      flex-shrink: 0;
  position: static;
  margin: 0;
  background: #292929;
  color: #fff;
}

.web-query-terms {
  -webkit-box-flex: 0;
      -ms-flex: none;
          flex: none;
  margin: 0;
  padding-left: 16px;
  overflow: visible;
  list-style: disc;
}

.web-query-terms li {
  color: #fff;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  overflow-wrap: anywhere;
}

.web-query-terms li::marker {
  color: #fff;
}

.web-query-link {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-negative: 0;
      flex-shrink: 0;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 4px;
  min-width: 0;
  margin-bottom: 12px;
  padding: 4px 6px;
  overflow: hidden;
  border: 1px solid #525252;
  border-radius: 4px;
  background: #333;
  color: #fff;
  font-size: 14px;
  line-height: 21px;
  text-decoration: none;
}

.web-query-link span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.web-query-link img {
  -webkit-filter: brightness(0) invert(1);
          filter: brightness(0) invert(1);
}

.web-query-link:hover span {
  text-decoration: underline;
}

.web-query-link:last-child {
  margin-bottom: 0;
}

.web-query-card--time {
  max-height: 320px;
}

.web-query-narrative {
  -ms-flex-negative: 0;
      flex-shrink: 0;
  margin: 0 0 8px;
  color: #fff;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  overflow-wrap: anywhere;
}

.sysnotes-menu-item {
  padding: 6px 12px;
  cursor: pointer;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 8px;
}

.sysnotes-menu-item:hover {
  background-color: #ebebeb;
}

.participants-menu-item:hover {
  background-color: #ebebeb;
}

.clickable-sysnotes {
  text-decoration: none;
}
.clickable-sysnotes:hover {
  text-decoration: underline;
}
.editor-content[data-ghost-hint]::after {
  color: #ccc;
  content: attr(data-ghost-hint);
  pointer-events: none;
}

h2 {
  margin: 0;
}

.not-supported-wrapper {
  height: 100vh;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  gap: 20px;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  background: #fff;
}

.openSlot {
  color: #333;
  border: 1px dashed #c2c2c2;
  background-color: #f5f5f5;
  background-image:
    -webkit-gradient(linear, left top, left bottom, from(rgba(74, 68, 89, 0.08)), to(rgba(74, 68, 89, 0.08))),
    url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  background-image:
    linear-gradient(rgba(74, 68, 89, 0.08), rgba(74, 68, 89, 0.08)),
    url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  background-repeat: no-repeat, no-repeat;
  background-position: center, center;
  background-size: cover, cover;
  letter-spacing: 0.25px;
}

.openSlot:hover {
  border-color: #8c8c8c;
}

.assignedSlot {
  background-color: #fff;
}

.assignedSlot:hover .checkbox-hidden {
  opacity: 1 !important;
}

.assignedSlot:hover {
  background-color: #cfe5fa;
}

.clockingActivitySlot:hover {
  background: #cfe5fa;
}

.mobileAssignedSlot {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  padding: 12px 0 12px 12px;
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: flex-start;
  gap: 12px;
  -ms-flex-item-align: stretch;
      align-self: stretch;
  overflow: hidden;
  border-radius: 4px;
  background: #fff;
  -webkit-box-shadow: 1px 2px 5px 0 rgba(51, 51, 51, 0.24);
          box-shadow: 1px 2px 5px 0 rgba(51, 51, 51, 0.24);
}

.clockingMobileActivitySlot {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  padding: 12px 0 12px 12px;
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: flex-start;
  gap: 12px;
  -ms-flex-item-align: stretch;
      align-self: stretch;
  overflow: hidden;
  border-radius: 4px;
}

.suggestedEntry {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  padding: 10px 0 10px 12px;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: flex-start;
  gap: 6px;
  -ms-flex-item-align: stretch;
      align-self: stretch;
  border-radius: 10px;
  background: #fff;
  position: relative;
}

.suggestedEntry:hover:not(:has(.timeEntryCard:hover)) {
  background-color: #cfe5fa;
}

.allSelectedGroup:hover {
  background: #cfe5fa;
}

.newGroup {
  border-radius: 10px;
  background: #cfe5fa;
}

.newGroup .timeEntryCard {
  background: inherit !important;
}

.timeEntryCard {
  position: relative;
}

.highlightedCard {
  background: #cfe5fa;
}

.timeEntryCard:hover {
  background: #cfe5fa;
  border-radius: 4px;
}

.workItemEntry .timeEntryCard:hover {
  background: #efeff0;
}

.timeEntryCard:active,
.timeEntryCard:focus {
  background: #fff !important;
  border-radius: 4px;
}

.disable-hover:hover {
  background: #fff !important;
}

/* MIRA-4344: keep Noise neutral, including matter labels and count badges.
   Opaque backgrounds prevent underlying matter colors from showing through. */
.noise-item {
  background: #ebebeb !important;
}
.noise-item:hover {
  background: #e0e0e0 !important;
}

.noise-item img {
  -webkit-filter: saturate(0);
          filter: saturate(0);
}

.noise-item [data-work-item-matter-client] {
  color: #999 !important;
}

.noise-item [data-work-item-timeslot-count] {
  background-color: #999 !important;
}

.noise-item .checkbox-hidden,
.noise-item .checkbox-visible,
.noise-item:hover .checkbox-hidden,
.noise-item:hover .checkbox-visible {
  opacity: 0 !important;
  pointer-events: none;
}

.noise-item .dragIconWrapper {
  cursor: not-allowed;
}

/* Timeline drag handle: outside the card on the left, lined up with the first
   source-icon row, shown only on hover.
   - No top/left: an absolutely positioned flex child keeps its static
     position, i.e. the row's start, vertically centered like the icon.
   - The negative margin moves it left by --drag-handle-card-inset: the
     distance from the row to the handle's right edge. It clears the card,
     its own matter color border and a group's matter color line, with a 4px
     gap, so the handle never sits on a line.
   - Its containing block stays outside cards with overflow: hidden, so it is
     not clipped. */
.dragIconWrapper {
  position: absolute;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  width: 16px;
  height: 16px;
  /* Suggested entry card: padding 8 + gap to the group line 12 + line 2 +
     4px gap = 26px. */
  margin-left: calc(-16px - var(--drag-handle-card-inset, 26px));
  cursor: -webkit-grab;
  cursor: grab;
}

.dragIconWrapper .dragIcon {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  visibility: hidden;
}

.assignedSlot:hover .dragIconWrapper .dragIcon,
.clockingActivitySlot:hover .dragIconWrapper .dragIcon,
.timeEntryCard:hover .dragIconWrapper .dragIcon,
.dragIconWrapper:hover .dragIcon {
  visibility: visible;
}

.dragIcon {
  display: none;
}

.workItemUnassignedMarker {
  position: absolute;
  top: 50%;
  left: -16px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
}

.workItemControlRail {
  position: absolute;
  top: 50%;
  left: -27px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  width: 16px;
  cursor: -webkit-grab;
  cursor: grab;
  -webkit-transform: translate(-50%, -4px);
          transform: translate(-50%, -4px);
}

.workItemControlRailDot {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: 8px;
  height: 8px;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-flex: 0;
      -ms-flex: 0 0 8px;
          flex: 0 0 8px;
}

.workItemControlRail .dragIcon {
  -webkit-box-flex: 0;
      -ms-flex: 0 0 16px;
          flex: 0 0 16px;
  margin-top: 16px;
}

.unassignedWorkItemIndicator {
  margin-right: 0;
}

.assignedSlot:hover .dragIcon {
  display: block;
}

.clockingActivitySlot:hover .dragIcon {
  display: block;
}

.dragIconWrapper:hover .dragIcon {
  display: block;
}

.timeEntryCard:hover .dragIcon {
  display: block;
}

.suggestedSlot {
  background: transparent;
  border-bottom: 1px solid #d9d9d9;
}

.suggestedSlot:hover {
  background: #d9eafb !important;
}

.suggestedSlot:last-child {
  border-bottom: none;
}

.inlineDurationEditor .inlineDurationInput,
.inlineDurationEditor .inlineDurationInput .k-input,
.inlineDurationEditor .inlineDurationInput .k-input-inner,
.inlineDurationEditor .inlineDurationInput .k-input-spinner,
.inlineDurationEditor .inlineDurationInput .k-input-button,
.inlineDurationEditor .inlineDurationInput .k-button,
.inlineDurationEditor .inlineDurationInput .k-spinner-increase,
.inlineDurationEditor .inlineDurationInput .k-spinner-decrease {
  background: transparent !important;
  -webkit-box-shadow: none !important;
          box-shadow: none !important;
}

.inlineDurationEditor .inlineDurationInput .k-input-inner,
.inlineDurationEditor .inlineDurationInput input {
  width: 30px !important;
  min-width: 30px !important;
  -webkit-box-flex: 0 !important;
      -ms-flex: 0 0 30px !important;
          flex: 0 0 30px !important;
  padding: 5px !important;
}

.inlineDurationEditor .inlineDurationInput .k-input-spinner {
  display: -webkit-box !important;
  display: -ms-flexbox !important;
  display: flex !important;
  width: 18px !important;
  min-width: 18px !important;
  -webkit-box-flex: 0 !important;
      -ms-flex: 0 0 18px !important;
          flex: 0 0 18px !important;
  opacity: 1 !important;
  visibility: visible !important;
}

.inlineDurationEditor .inlineDurationInput .k-input-spinner,
.inlineDurationEditor .inlineDurationInput .k-input-button,
.inlineDurationEditor .inlineDurationInput .k-button {
  border-left: 0 !important;
}

.inlineDurationEditor .inlineDurationInput .k-spinner-increase,
.inlineDurationEditor .inlineDurationInput .k-spinner-decrease {
  border-color: transparent !important;
}

.inlineDurationEditor--confirmation {
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  -webkit-box-align: stretch !important;
      -ms-flex-align: stretch !important;
          align-items: stretch !important;
  -webkit-box-pack: start;
      -ms-flex-pack: start;
          justify-content: flex-start;
  width: 100%;
}

.inlineDurationEditor__actions {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: flex-start;
  -webkit-box-pack: end;
      -ms-flex-pack: end;
          justify-content: flex-end;
  gap: 8px;
  width: 100%;
}

.inlineDurationEditor__button {
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  height: 30px;
  padding: 0 12px;
  border: 0.6px solid #d9d9d9;
  border-radius: 999px;
  font-family: inherit;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.33;
  letter-spacing: 0.5px;
  white-space: nowrap;
  cursor: pointer;
}

.inlineDurationEditor__button--close {
  min-width: 55px;
  border-color: #fff;
  background: transparent;
  color: #fff;
}

.inlineDurationEditor__button--close:hover {
  background: rgba(255, 255, 255, 0.12);
}

.inlineDurationEditor__button--save {
  min-width: 60px;
  background: #fff;
  color: #333;
}

.inlineDurationEditor__button--save:hover {
  background: -webkit-gradient(linear, left bottom, left top, from(rgba(74, 68, 89, 0.08)), to(rgba(74, 68, 89, 0.08))), #FFF;
  background: linear-gradient(0deg, rgba(74, 68, 89, 0.08) 0%, rgba(74, 68, 89, 0.08) 100%), #FFF;
}

.inlineDurationEditor--inversePopup .inlineDurationInput,
.inlineDurationEditor--inversePopup .inlineDurationInput .k-input,
.inlineDurationEditor--inversePopup .inlineDurationInput .k-input-inner,
.inlineDurationEditor--inversePopup .inlineDurationInput .k-input-spinner,
.inlineDurationEditor--inversePopup .inlineDurationInput .k-input-button,
.inlineDurationEditor--inversePopup .inlineDurationInput .k-button,
.inlineDurationEditor--inversePopup .inlineDurationInput .k-spinner-increase,
.inlineDurationEditor--inversePopup .inlineDurationInput .k-spinner-decrease {
  background: #fff !important;
  color: #333 !important;
}

.inlineDurationEditor--inversePopup .inlineDurationInput {
  height: 28px !important;
  border: 1px solid #d9d9d9 !important;
  border-radius: 4px !important;
  -webkit-box-sizing: border-box !important;
          box-sizing: border-box !important;
}

.inlineDurationEditor--inversePopup .inlineDurationInput.k-focus,
.inlineDurationEditor--inversePopup .inlineDurationInput:focus-within {
  border-color: #8b3dff !important;
}

.inlineDurationEditor--inversePopup .inlineDurationInput .k-input-inner,
.inlineDurationEditor--inversePopup .inlineDurationInput input {
  color: #333 !important;
  font-size: 14px !important;
  line-height: 1.42 !important;
}

.suggestMatterOption {
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  border-radius: 4px;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  height: 32px;
  background:
    -webkit-gradient(
      linear,
      left top, right top,
      from(rgba(134, 91, 223, 0.15)),
      to(rgba(60, 163, 244, 0.15))
    ),
    #fff;
  background:
    linear-gradient(
      90deg,
      rgba(134, 91, 223, 0.15) 0%,
      rgba(60, 163, 244, 0.15) 100%
    ),
    #fff;
  color: #525252;
  overflow: hidden;
  font-weight: 600;
}

.entryMatterOption {
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  border-radius: 4px;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  font-weight: 600;
  cursor: pointer;
  overflow: hidden;
  height: 32px;
}

.leftMatterOption {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 6px;
  padding: 6px 4px 6px 6px;
  border-radius: 4px 0 0 4px;
}

.rightMatterOption {
  padding: 6px;
  border-radius: 0 4px 4px 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.entryMatterOption .leftMatterOption:hover {
  background: rgba(0, 0, 0, 0.3);
  height: 100%;
  border-radius: 4px 0 0 4px;
}

.entryMatterOption .rightMatterOption:hover {
  background: rgba(0, 0, 0, 0.3);
  height: 100%;
  border-radius: 0 4px 4px 0;
}

.suggestMatterOption .leftMatterOption:hover {
  color: #fff;
  background: -webkit-gradient(linear, left top, left bottom, from(#865bdf), to(#6595e6));
  background: linear-gradient(180deg, #865bdf 0%, #6595e6 100%);
  height: 100%;
  border-radius: 4px 0 0 4px;
}

.suggestMatterOption .rightMatterOption:hover {
  color: #fff;
  background: -webkit-gradient(linear, left top, left bottom, from(#865bdf), to(#6595e6));
  background: linear-gradient(180deg, #865bdf 0%, #6595e6 100%);
  height: 100%;
  border-radius: 0 4px 4px 0;
}

.generateIcon {
  width: 16px;
  height: 16px;
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_37___});
}

.suggestMatterOption .leftMatterOption:hover .generateIcon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
}

.entryMatterOption .generateIcon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
}

.checkIcon {
  width: 16px;
  height: 16px;
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
}

.suggestMatterOption:hover .checkIcon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_40___});
}

.entryMatterOption .checkIcon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_40___});
}

.closeIcon {
  width: 16px;
  height: 16px;
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_41___});
}

.suggestMatterOption:hover .closeIcon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_42___});
}

.extraCount {
  background-color: #f5f5f5;
}

.extraCount:hover {
  background-color: #e7e7e9;
}

.recent-matter-option {
  background: #fff;
  height: 30px;
}

.recent-matter-option:hover {
  background: #f1f0f2;
  border-radius: 40px;
}

.tooltipContainer div {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.totalHour {
  color: #865bdf;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 133%;
  letter-spacing: 0;
}

.totalUnit {
  color: #865bdf;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 30px;
  letter-spacing: 0;
}

.totalWeekHour {
  color: #865bdf;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 133%;
  letter-spacing: 0;
}

.totalWeekUnit {
  color: #865bdf;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 30px;
  letter-spacing: 0;
}

.releaseHour {
  color: #009688;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 133%;
  letter-spacing: 0;
}

.releaseUnit {
  color: #009688;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 30px;
  letter-spacing: 0;
}

.readyHour {
  color: #2C6DDD;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 133%;
  letter-spacing: 0;
}

.readyUnit {
  color: #2C6DDD;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 30px;
  letter-spacing: 0;
}

.billableHour {
  color: #333;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 133%;
  letter-spacing: 0;
}

.billableUnit {
  color: #333;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 30px;
  letter-spacing: 0;
}

.scheduleMaintenance {
  width: calc(100% + 20px);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  height: 56px;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  padding: 8px 40px 8px 20px;
  -webkit-transform: translateX(-20px);
          transform: translateX(-20px);
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -ms-flex-item-align: stretch;
      align-self: stretch;
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_43___});
  background-size: cover;
}

.floatingMergeBtn {
  width: 46px;
  height: 46px;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  padding: 8px;
  border: none;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 8px;
  border-radius: 16px;
  background: #4a4459;
  -webkit-box-shadow:
    0 1px 2px 0 rgba(0, 0, 0, 0.3),
    0 1px 3px 1px rgba(0, 0, 0, 0.15);
          box-shadow:
    0 1px 2px 0 rgba(0, 0, 0, 0.3),
    0 1px 3px 1px rgba(0, 0, 0, 0.15);
}

.floatingMergeDisabledBtn {
  width: 46px;
  height: 46px;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  padding: 8px;
  border: none;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 8px;
  border-radius: 16px;
  background: #999;
  -webkit-box-shadow:
    0 1px 2px 0 rgba(0, 0, 0, 0.3),
    0 1px 3px 1px rgba(0, 0, 0, 0.15);
          box-shadow:
    0 1px 2px 0 rgba(0, 0, 0, 0.3),
    0 1px 3px 1px rgba(0, 0, 0, 0.15);
}

.floatingMergeBtn:hover {
  background: #332d41;
}

.floatingMergeDisabledBtn:hover {
  background: #757575;
}

.checkbox-hidden {
  opacity: 0;
  /* pointer-events: none;  */
  -webkit-transition: opacity 0.15s ease;
  transition: opacity 0.15s ease;
}

.checkbox-visible {
  opacity: 1;
  /* pointer-events: auto; */
  -webkit-transition: opacity 0.15s ease;
  transition: opacity 0.15s ease;
}

.common-radio {
  width: 14px;
  height: 14px;
  accent-color: #865bdf;
  margin: 0;
}

.tooltip-btn {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  height: 30px;
  padding: 0 12px;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 4px;
  border-radius: 999px;
  border: 1px solid #fff;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
}

.tooltip-btn:hover {
  background: rgba(255, 255, 255, 0.12);
}

.combo-error.k-combobox {
  border: 1px solid #b3261e !important;
}

.clockingDisabled {
  /* background: #F7F7F8;
    color: #9E9E9E;
    cursor: default; */
}

.clockingDisabled:hover {
  /* background: #F7F7F8; */
}

.clockingDisabled img {
  opacity: 0.65;
}

.clockingDisabled .dragIcon img,
.clockingDisabled canvas,
.clockingGroupDragIcon .dragIcon img {
  opacity: 1;
}

.clockingDisabled .k-tooltip,
.clockingDisabled .k-tooltip *,
.clockingGroupDragIcon .k-tooltip,
.clockingGroupDragIcon .k-tooltip * {
  color: #fff !important;
  opacity: 1;
}

/* Two-dot button loader (DotsLoader): the dots pulse in turn. */
.dots-loader {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 2px;
  -ms-flex-negative: 0;
      flex-shrink: 0;
}

.dots-loader > span {
  display: block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: currentColor;
  -webkit-animation: dots-loader-pulse 0.9s ease-in-out infinite;
          animation: dots-loader-pulse 0.9s ease-in-out infinite;
}

.dots-loader > span:nth-child(2) {
  -webkit-animation-delay: -0.45s;
          animation-delay: -0.45s;
}

@-webkit-keyframes dots-loader-pulse {
  0%,
  100% {
    -webkit-transform: scale(0.6);
            transform: scale(0.6);
  }
  50% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
}

@keyframes dots-loader-pulse {
  0%,
  100% {
    -webkit-transform: scale(0.6);
            transform: scale(0.6);
  }
  50% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
}


@property --move-border-angle {
  syntax: '<angle>';
  initial-value: 0deg;
  inherits: false;
}

.time-entry-move-highlight {
  position: relative;
}

.time-entry-move-highlight::after {
  content: '';
  position: absolute;
  inset: 0;
  z-index: 1101;
  border-radius: 6px;
  padding: 2px;
  background: conic-gradient(from var(--move-border-angle), #865BDF, #4285F4, #34A853, #FBBC05, #EA4335, #865BDF);
  -webkit-mask: -webkit-gradient(linear, left top, left bottom, color-stop(0, #fff)) content-box, -webkit-gradient(linear, left top, left bottom, color-stop(0, #fff));
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
          mask: -webkit-gradient(linear, left top, left bottom, color-stop(0, #fff)) content-box, -webkit-gradient(linear, left top, left bottom, color-stop(0, #fff));
          mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
          mask-composite: exclude;
  pointer-events: none;
  -webkit-animation: time-entry-move-border 3s linear both;
          animation: time-entry-move-border 3s linear both;
}

@-webkit-keyframes time-entry-move-border {
  0% { --move-border-angle: 0deg; opacity: 1; }
  85% { opacity: 1; }
  100% { --move-border-angle: 360deg; opacity: 0; }
}

@keyframes time-entry-move-border {
  0% { --move-border-angle: 0deg; opacity: 1; }
  85% { opacity: 1; }
  100% { --move-border-angle: 360deg; opacity: 0; }
}

@media (prefers-reduced-motion: reduce) {
  .time-entry-move-highlight::after {
    -webkit-animation-name: time-entry-move-border-static;
            animation-name: time-entry-move-border-static;
  }
}

@-webkit-keyframes time-entry-move-border-static {
  0%, 85% { opacity: 1; }
  100% { opacity: 0; }
}

@keyframes time-entry-move-border-static {
  0%, 85% { opacity: 1; }
  100% { opacity: 0; }
}
`, "",{"version":3,"sources":["webpack://./src/css/Common.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE;IACE,+BAAuB;YAAvB,uBAAuB;EACzB;EACA;IACE,iCAAyB;YAAzB,yBAAyB;EAC3B;AACF;;AAPA;EACE;IACE,+BAAuB;YAAvB,uBAAuB;EACzB;EACA;IACE,iCAAyB;YAAzB,yBAAyB;EAC3B;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EAEX,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,sDAA8C;UAA9C,8CAA8C;EAC9C,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,sDAA8C;UAA9C,8CAA8C;EAC9C,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,sDAA8C;UAA9C,8CAA8C;EAC9C,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gDAAwD;AAC1D;;AAEA;EACE,gDAAyD;AAC3D;;AAEA;EACE,gDAAwD;AAC1D;;AAEA;EACE,gDAAsD;AACxD;;AAEA;;EAEE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,YAAY;EACZ,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,mDAA2C;UAA3C,2CAA2C;AAC7C;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gDAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gDAA0D;AAC5D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gDAAyD;AAC3D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gDAAyC;AAC3C;;AAEA;EACE,gDAAuD;AACzD;;AAEA;EACE,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gDAA6D;AAC/D;;AAEA;EACE,gDAAwD;AAC1D;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,WAAW;EACX,YAAY;EACZ,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,8BAAsB;UAAtB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,WAAW;EACX,YAAY;EACZ,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;EACT,oBAAc;MAAd,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,8BAAsB;UAAtB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,2BAA2B;EAC3B,6BAA6B;EAC7B,0DAAgE;AAClE;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,cAAc;EACd,eAAe;EACf,qBAAyB;MAAzB,kBAAyB;UAAzB,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,YAAY;EACZ,WAAW;EACX,4BAA4B;EAC5B,2BAA2B;EAC3B,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,0DAA2D;AAC7D;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,0DAA+D;AACjE;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,YAAY;EACZ,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,mBAAe;MAAf,eAAe;EACf,SAAS;AACX;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,iBAAiB;EACjB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,0BAAkB;EAAlB,uBAAkB;EAAlB,kBAAkB;EAClB,8BAAsB;UAAtB,sBAAsB;EACtB,QAAQ;EAGR,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,uDAA+C;UAA/C,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,uDAA+C;UAA/C,+CAA+C;AACjD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,6BAA6B;EAC7B,0DAA8D;AAChE;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,6BAA6B;EAC7B,0DAA6D;AAC/D;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,OAAO;AACT;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,WAAW;EACX,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0DAAoE;AACtE;AACA;EACE,0DAAuE;AACzE;AACA;EACE,eAAe;EACf,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,8BAAsB;UAAtB,sBAAsB;EACtB,gBAAgB;EAChB,wBAAwB;EACxB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB,EAAE,YAAY;EACnC,wBAAwB,EAAE,mBAAmB;AAC/C;;AAEA;EACE,aAAa,EAAE,kBAAkB;AACnC;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAO;MAAP,WAAO;UAAP,OAAO;AACT;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sDAA8C;UAA9C,8CAA8C;EAC9C,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,6BAA6B;EAC7B,0DAA4D;AAC9D;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,6BAA6B;EAC7B,0DAA8D;AAChE;;AAEA;EACE,0DAA4D;AAC9D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,6BAA6B;EAC7B,0DAA0D;AAC5D;;AAEA;EACE,0DAAmE;AACrE;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,6BAA6B;EAC7B,0DAA2D;AAC7D;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,6BAA6B;EAC7B,0DAA0D;AAC5D;;AAEA;EACE,0DAAwD;AAC1D;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,YAAY;EACZ,eAAe;EACf,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,YAAY;EACZ,eAAe;EACf,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE;;IAEE,YAAY;IACZ,eAAe;IACf,mBAAmB;EACrB;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,QAAQ;EACR,wCAAgC;UAAhC,gCAAgC;AAClC;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,2BAA2B;EAC3B,6BAA6B;EAC7B,0DAA6D;AAC/D;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,0DAA2D;AAC7D;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,oBAAoB,EAAE,SAAS;EAC/B,yBAAiB;KAAjB,sBAAiB;MAAjB,qBAAiB;UAAjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,0BAA0B;AAC5B;;AAEA,+BAA+B;AAC/B;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,YAAY,EAAE,cAAc;EAC5B,WAAW;EACX,uDAA+C;UAA/C,+CAA+C;EAC/C,uBAAuB;EACvB,WAAW,EAAE,cAAc;AAC7B;;AAEA;EACE,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAAqB;EAArB,qBAAqB;AACvB;;AAEA,8EAA8E;AAC9E,4CAA4C;AAC5C;EACE,iDAAmD;AACrD;;AAEA;EACE,iDAAoD;AACtD;;AAEA,cAAc;AACd;EACE,YAAY;EACZ,wBAAgB;UAAhB,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,+CAA+C;AACjD;;AAEA;EACE,mCAA2B;UAA3B,2BAA2B;AAC7B;;AAEA,cAAc;AACd;EACE,YAAY;EACZ,wBAAgB;UAAhB,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,2BAA2B;AAC7B;;AAEA;EACE,mCAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,8DAAsD;UAAtD,sDAAsD;EACtD,aAAa;EACb,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,mCAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B,EAAE,kBAAkB;AAChD;;AAEA;EACE,qBAAqB,EAAE,YAAY;EACnC,wBAAwB,EAAE,WAAW;AACvC;AACA;EACE,QAAQ;EACR,SAAS;AACX;AACA;EACE,QAAQ;EACR,SAAS;AACX;;AAEA;;EAEE,iCAAiC;EACjC,8BAA8B;EAC9B,uBAAmB;MAAnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,iBAAiB;EACjB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,iBAAiB;EACjB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,iBAAiB;EACjB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE;IACE,iBAAiB;IACjB,oBAAoB;EACtB;AACF;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;;EAGE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,QAAQ;EACR,wBAAkB;MAAlB,qBAAkB;UAAlB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,WAAW;EACX,YAAY;EACZ,cAAc;EACd,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,gBAAgB;EAChB,8BAAsB;UAAtB,sBAAsB;AACxB;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;;;;GAIG;;AAEH;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,oBAAoB;EACpB,mDAA2C;UAA3C,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,qBAAyB;MAAzB,kBAAyB;UAAzB,yBAAyB;EACzB,QAAQ,EAAE,aAAa;EACvB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;EAClB,oFAA0D;EAA1D,0DAA0D;EAC1D,aAAa;AACf;;AAEA;EACE;;;IAGE,0BAA0B;EAC5B;AACF;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,2CAAmC;UAAnC,mCAAmC;AACrC;;AAEA;EACE,sDAA8C;UAA9C,8CAA8C;EAC9C,8BAA8B;AAChC;AACA;EACE,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kEAA0D;UAA1D,0DAA0D;AAC5D;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,2BAA2B;EAC3B,6BAA6B;EAC7B,0DAAiE;EACjE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,aAAa;EACb,wBAAgB;UAAhB,gBAAgB;AAClB;AACA;EACE,0DAAuE;AACzE;AACA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,2BAA2B;EAC3B,6BAA6B;EAC7B,0DAAiE;EACjE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,aAAa;EACb,wBAAgB;UAAhB,gBAAgB;AAClB;AACA;EACE,0DAAuE;AACzE;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,0DAAkD;UAAlD,kDAAkD;AACpD;;AAEA;;;;;EAKE,YAAY;EACZ,uBAAuB;EACvB,wBAAgB;UAAhB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,8BAAsB;UAAtB,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,0DAAkD;UAAlD,kDAAkD;AACpD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,oBAAc;MAAd,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAU;MAAV,cAAU;UAAV,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,oBAAc;MAAd,cAAc;EACd,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,uCAA+B;UAA/B,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAc;MAAd,cAAc;EACd,eAAe;EACf,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,SAAS;EACT,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,yBAAyB;EACzB;;4CAE8C;EAF9C;;4CAE8C;EAC9C,uCAAuC;EACvC,mCAAmC;EACnC,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAyB;EACzB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,SAAS;EACT,4BAAmB;MAAnB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,wDAAgD;UAAhD,gDAAgD;AAClD;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAyB;EACzB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,SAAS;EACT,4BAAmB;MAAnB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAyB;EACzB,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,QAAQ;EACR,4BAAmB;MAAnB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;8EAC8E;AAC9E;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAAmB;UAAnB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;;;EAIE,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;;;;;;mBASmB;AACnB;EACE,kBAAkB;EAClB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ;sBACoB;EACpB,8DAA8D;EAC9D,oBAAY;EAAZ,YAAY;AACd;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,kBAAkB;AACpB;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,wCAAgC;UAAhC,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,WAAW;EACX,oBAAY;EAAZ,YAAY;EACZ,wCAAgC;UAAhC,gCAAgC;AAClC;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,UAAU;EACV,WAAW;EACX,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,mBAAa;MAAb,iBAAa;UAAb,aAAa;AACf;;AAEA;EACE,mBAAc;MAAd,kBAAc;UAAd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;;;;;EAQE,kCAAkC;EAClC,mCAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;;EAEE,sBAAsB;EACtB,0BAA0B;EAC1B,8BAAyB;MAAzB,6BAAyB;UAAzB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,+BAAwB;EAAxB,+BAAwB;EAAxB,wBAAwB;EACxB,sBAAsB;EACtB,0BAA0B;EAC1B,8BAAyB;MAAzB,6BAAyB;UAAzB,yBAAyB;EACzB,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,qCAA+B;MAA/B,kCAA+B;UAA/B,+BAA+B;EAC/B,uBAA2B;MAA3B,oBAA2B;UAA3B,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,qBAAyB;MAAzB,kBAAyB;UAAzB,yBAAyB;EACzB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,8BAAsB;UAAtB,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,2BAA2B;EAC3B,oBAAoB;EACpB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,2HAA+F;EAA/F,+FAA+F;AACjG;;AAEA;;;;;;;;EAQE,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,6BAA6B;EAC7B,yCAAiC;UAAjC,iCAAiC;AACnC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,sBAAsB;EACtB,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,0BAAkB;EAAlB,uBAAkB;EAAlB,kBAAkB;EAClB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,kBAAkB;EAClB,8BAAsB;UAAtB,sBAAsB;EACtB,YAAY;EACZ;;;;;;;QAMM;EANN;;;;;;QAMM;EACN,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,0BAAkB;EAAlB,uBAAkB;EAAlB,kBAAkB;EAClB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,kBAAkB;EAClB,8BAAsB;UAAtB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,oBAAa;EAAb,oBAAa;EAAb,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,uFAA6D;EAA7D,6DAA6D;EAC7D,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,uFAA6D;EAA7D,6DAA6D;EAC7D,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,2BAA2B;EAC3B,6BAA6B;EAC7B,0DAAiE;AACnE;;AAEA;EACE,0DAAuE;AACzE;;AAEA;EACE,0DAAuE;AACzE;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,2BAA2B;EAC3B,6BAA6B;EAC7B,0DAA6D;AAC/D;;AAEA;EACE,0DAAmE;AACrE;;AAEA;EACE,0DAAmE;AACrE;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,2BAA2B;EAC3B,6BAA6B;EAC7B,0DAA6D;AAC/D;;AAEA;EACE,0DAAmE;AACrE;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,YAAY;EACZ,8BAAsB;UAAtB,sBAAsB;EACtB,0BAA0B;EAC1B,oCAA4B;UAA5B,4BAA4B;EAC5B,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,4BAAmB;MAAnB,mBAAmB;EACnB,4BAA4B;EAC5B,2BAA2B;EAC3B,6BAA6B;EAC7B,0DAA4D;EAC5D,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,YAAY;EACZ,YAAY;EACZ,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB;;qCAEmC;UAFnC;;qCAEmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,YAAY;EACZ,YAAY;EACZ,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB;;qCAEmC;UAFnC;;qCAEmC;AACrC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,2BAA2B;EAC3B,sCAA8B;EAA9B,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,0BAA0B;EAC1B,sCAA8B;EAA9B,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,YAAY;EACZ,eAAe;EACf,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,sBAAsB;EACtB,0BAAkB;EAAlB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE;;sBAEoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;;;EAGE,UAAU;AACZ;;AAEA;;;;EAIE,sBAAsB;EACtB,UAAU;AACZ;;AAEA,gEAAgE;AAChE;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,oBAAc;MAAd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,8DAAsD;UAAtD,sDAAsD;AACxD;;AAEA;EACE,+BAAuB;UAAvB,uBAAuB;AACzB;;AAEA;EACE;;IAEE,6BAAqB;YAArB,qBAAqB;EACvB;EACA;IACE,2BAAmB;YAAnB,mBAAmB;EACrB;AACF;;AARA;EACE;;IAEE,6BAAqB;YAArB,qBAAqB;EACvB;EACA;IACE,2BAAmB;YAAnB,mBAAmB;EACrB;AACF;;;AAGA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,+GAA+G;EAC/G,oKAA8E;EAA9E,8EAA8E;EAC9E,2BAA2B;EAC3B,8EAAsE;UAAtE,4JAAsE;UAAtE,sEAAsE;EACtE,2BAAuB;UAAvB,uBAAuB;EACvB,oBAAoB;EACpB,wDAAgD;UAAhD,gDAAgD;AAClD;;AAEA;EACE,KAAK,yBAAyB,EAAE,UAAU,EAAE;EAC5C,MAAM,UAAU,EAAE;EAClB,OAAO,2BAA2B,EAAE,UAAU,EAAE;AAClD;;AAJA;EACE,KAAK,yBAAyB,EAAE,UAAU,EAAE;EAC5C,MAAM,UAAU,EAAE;EAClB,OAAO,2BAA2B,EAAE,UAAU,EAAE;AAClD;;AAEA;EACE;IACE,qDAA6C;YAA7C,6CAA6C;EAC/C;AACF;;AAEA;EACE,UAAU,UAAU,EAAE;EACtB,OAAO,UAAU,EAAE;AACrB;;AAHA;EACE,UAAU,UAAU,EAAE;EACtB,OAAO,UAAU,EAAE;AACrB","sourcesContent":["body {\n  overflow: hidden;\n  margin: 0;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.css-95 {\n  padding: 0 0 0 20px;\n}\n\n.text-hover {\n  color: #865bdf;\n  font-size: 14px;\n  font-weight: 400;\n  cursor: pointer;\n}\n\n.text-hover:hover {\n  text-decoration: underline;\n}\n\n.text-link {\n  color: #0d81d5;\n  font-size: 12px;\n  font-weight: 400;\n  text-decoration-line: underline;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.btn-text-active {\n  font-size: 14px;\n  height: 30px;\n  line-height: 30px;\n  border-radius: 30px;\n  border: 1px solid #d9d9d9;\n  background: #865bdf;\n  border-color: #865bdf;\n  color: #fff;\n  display: inline-block;\n  vertical-align: top;\n  padding: 0px 12px;\n  cursor: pointer;\n}\n\n.btn-disabled {\n  background: #999;\n  color: #fff;\n  cursor: not-allowed;\n  border: 1px solid #999;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n\n.btn-text-inactive {\n  font-size: 14px;\n  height: 30px;\n  line-height: 30px;\n  border-radius: 30px;\n  border: 1px solid #d9d9d9;\n  color: #333;\n  display: inline-block;\n  vertical-align: top;\n  padding: 0px 12px;\n  cursor: pointer;\n}\n\n.btn-text-inactive:hover {\n  background: #f2f4ff;\n}\n\n.option-text-active {\n  height: 22px;\n  line-height: 22px;\n  border-radius: 4px;\n  border: 1px solid #865bdf;\n  background: #865bdf;\n  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);\n  color: #fff;\n  padding: 0px 10px;\n  font-size: 12px;\n  font-weight: 400;\n  cursor: pointer;\n}\n\n.option-text-inactive {\n  height: 22px;\n  line-height: 22px;\n  border-radius: 4px;\n  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);\n  color: #333;\n  padding: 0px 10px;\n  font-size: 12px;\n  font-weight: 400;\n  cursor: pointer;\n  border: 1px solid #fff;\n}\n\n.option-text-inactive:hover {\n  border: 1px solid #865bdf;\n  background: #ede6fa;\n  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);\n  color: #865bdf;\n}\n\n.btn-action {\n  font-size: 14px;\n  height: 30px;\n  line-height: 30px;\n  border-radius: 30px;\n  border: 1px solid #dadada;\n  background: #fff;\n  color: #333;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  vertical-align: top;\n  padding: 0px 12px;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.btn-action:hover {\n  background: #d9d9d9;\n  border-color: #d9d9d9;\n}\n\n.btn-action:disabled {\n  background: #999;\n  color: #fff;\n  cursor: not-allowed;\n  border: 1px solid #999;\n}\n\n.btn-action-disabled {\n  font-size: 14px;\n  cursor: not-allowed;\n  height: 30px;\n  line-height: 30px;\n  border-radius: 30px;\n  background: #999;\n  color: #fff;\n  vertical-align: top;\n  padding: 0px 12px;\n  border: 1px solid #999;\n}\n\n.btn-action img,\n.btn-action-disabled img {\n  width: 16px;\n}\n\n.btn-more {\n  display: flex;\n  min-height: 24px;\n  min-width: 16px;\n  padding: 0;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 4px;\n}\n\n.btn-more-mobile {\n  margin-right: 6px;\n}\n\n.btn-status:hover .btn-status-count {\n  background: #5e409c;\n}\n\n.btn-release img {\n  content: url('../public/assets/action/icon_release.svg');\n}\n\n.btn-accept-release img {\n  content: url('../public/assets/action/check_outline.svg');\n}\n\n.btn-restore img {\n  content: url('../public/assets/button/icon_restore.svg');\n}\n\n.btn-merge img {\n  content: url('../public/assets/action/icon_merge.svg');\n}\n\n.btn-close-panel,\n.btn-expand-panel {\n  display: flex;\n  padding: 6px;\n  align-items: center;\n  gap: 10px;\n  border-radius: 5px;\n  background: #fff;\n  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);\n}\n\n.btn-close-panel:hover,\n.btn-expand-panel:hover {\n  background: #d9d9d9;\n}\n\n.btn-expand-panel img {\n  width: 16px;\n  height: 16px;\n  content: url('../public/assets/menu.svg');\n}\n\n.btn-dashboard img {\n  width: 16px;\n  height: 16px;\n  content: url('../public/assets/button/icon_dashboard.svg');\n}\n\n.btn-grid img {\n  width: 16px;\n  height: 16px;\n  content: url('../public/assets/button/icon_grid_row.svg');\n}\n\n.btn-close-panel img {\n  width: 16px;\n  height: 16px;\n  content: url('../public/assets/menu.svg');\n}\n\n.btn-action-delete img {\n  content: url('../public/assets/action/icon_delete.svg');\n}\n\n.btn-action-delete-disabled {\n  background: #999999 !important;\n  color: #fff;\n  cursor: not-allowed;\n  border: none !important;\n}\n\n.btn-action-delete-disabled img {\n  content: url('../public/assets/action/icon_delete_white.svg');\n}\n\n.btn-action-discard img {\n  content: url('../public/assets/action/icon_discard.svg');\n}\n\n.btn-delete {\n  border-radius: 40px;\n  border: 1px solid #ff444b;\n  background: #ff444b;\n  display: flex;\n  width: 30px;\n  height: 30px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n}\n\n.btn-delete:hover {\n  border: 1px solid #e60022;\n  background: #e60022;\n}\n\n.btn-delete:disabled {\n  border: 1px solid #999;\n  background: #999;\n}\n\n.btn-image {\n  box-sizing: border-box;\n  border-radius: 50%;\n  border: 1px solid #dadada;\n  background: #fff;\n  color: #333;\n  display: flex;\n  width: 30px;\n  height: 30px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n}\n\n.btn-image:hover {\n  border: 1px solid #d9d9d9;\n  background: #d9d9d9;\n}\n\n.btn-image:disabled {\n  color: #fff;\n  border: 1px solid #999;\n  background: #999;\n}\n\n.btn-magic {\n  box-sizing: border-box;\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  border: 1px solid #dadada;\n  background: #fff;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n\n.btn-magic:hover {\n  background: #d9d9d9;\n}\n\n.magic {\n  width: 17px;\n  height: 17px;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url('../public/assets/magic_wand_default.svg');\n}\n\n.btn-return {\n  display: flex;\n  color: #865bdf;\n  font-size: 14px;\n  justify-content: flex-end;\n  font-weight: 400;\n  background: transparent;\n  text-decoration-line: underline;\n  cursor: pointer;\n}\n\n.dashboard-weather-icon {\n  margin-top: 20px;\n  margin-left: 5%;\n  padding: 0;\n  border: none;\n  float: left;\n  background-repeat: no-repeat;\n  background-position: center;\n  width: 100px;\n  height: 100px;\n}\n\n.dashboard-weather-clouds {\n  background-image: url('../public/assets/cloudy_export.svg');\n}\n\n.dashboard-weather-clear {\n  background-image: url('../public/assets/sunny_export.svg');\n}\n\n.dashboard-weather-snow {\n  background-image: url('../public/assets/snowy_export.svg');\n}\n\n.dashboard-weather-rain {\n  background-image: url('../public/assets/heavy_rain_export.svg');\n}\n\n.highlight-column {\n  cursor: pointer;\n  /* background-color: #fff; */\n}\n\n.select-container {\n  display: flex;\n  padding: 8px;\n  align-items: center;\n  height: calc(100% - 10px);\n  gap: 4px;\n  justify-content: space-between;\n  color: #333;\n  font-size: 24px;\n  font-weight: 500;\n}\n\n.summary-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.summary-day {\n  color: #865bdf;\n  text-align: center;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 510;\n  line-height: 34px;\n}\n\n.summary-hr-container {\n  display: flex;\n  padding: 12px 8px;\n  align-items: center;\n  width: fit-content;\n  box-sizing: border-box;\n  gap: 8px;\n  border-radius: 4px;\n  background: #fff;\n  color: #333;\n  font-size: 24px;\n  font-weight: 500;\n  border-radius: 4px;\n  background: #fff;\n  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.11);\n}\n\n.summary-hr-container:hover {\n  background: #f2f4ff;\n  /* Component/Small Component */\n  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.11);\n}\n\n.summary-hr-container:active {\n  border: 2px solid #865bdf;\n}\n\n.summary-hr {\n  color: #333;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n}\n\n.m-icon-right-arrow {\n  width: 24px;\n  height: 24px;\n  background-size: 24px 24px;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url('../public/assets/icon_right_arrow.svg');\n}\n\n.m-icon-left-arrow {\n  width: 24px;\n  height: 24px;\n  background-size: 24px 24px;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url('../public/assets/icon_left_arrow.svg');\n}\n\n.week-option-selected {\n  position: relative;\n  color: #865bdf !important;\n  background: #fff;\n}\n\n.week-option-selected .selected-border {\n  height: 3px;\n  width: 100%;\n  border-radius: 1px;\n  background: #865bdf;\n  position: absolute;\n  bottom: 0px;\n  left: 0;\n}\n\n.week-row {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n.week-option {\n  color: #999;\n  padding: 4px 0;\n  height: 100%;\n}\n\n.week-option:hover {\n  color: #865bdf;\n}\n\n.week-option:hover .week-hour .total-icon {\n  background-image: url('../public/assets/icon_total_hours_hover.svg');\n}\n.week-option:hover .week-hour .billable-icon {\n  background-image: url('../public/assets/icon_billable_hours_hover.svg');\n}\n.week-title {\n  cursor: pointer;\n  display: flex;\n  border-radius: 4px;\n  min-width: 72px;\n  box-sizing: border-box;\n  min-height: 32px;\n  padding: 2px 0px 4px 0px;\n  justify-content: center;\n  align-items: center;\n  gap: 4px;\n  font-size: 16px;\n  font-weight: 400;\n  position: relative;\n}\n.week-title:hover {\n  background: #f1f0f2 !important;\n}\n\n.week-title-selected {\n  background: transparent !important;\n}\n.week-title-selected:hover {\n  background: transparent !important;\n}\n\n.divider-line {\n  width: 1px;\n  height: 14px;\n  background: #d8d8d8;\n  margin: 0 4px;\n}\n\n.page-description {\n  color: #333;\n  font-size: 14px;\n  font-weight: 400;\n}\n\n.border-circle {\n  width: 4px;\n  height: 4px;\n  border-radius: 2px;\n  background: #dadada;\n  margin: auto 8px;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.fixed-header {\n  padding: 0 0 12px;\n  z-index: 2000;\n  position: sticky;\n  align-items: center;\n  background-color: #fff;\n}\n\n.grid-wrapper {\n  /* height: calc(100vh - 180px); */\n  min-height: 400px;\n  overflow-y: auto;\n  /* —— 隐藏滚动条 —— */\n  scrollbar-width: none; /* Firefox */\n  -ms-overflow-style: none; /* IE/Edge legacy */\n}\n\n.grid-wrapper::-webkit-scrollbar {\n  display: none; /* Chrome/Safari */\n}\n\n.k-grid-header {\n  position: sticky;\n  top: 0;\n  background: white;\n  z-index: 10;\n}\n\n.css-59 {\n  padding: 0px 20px !important;\n}\n\n.greeting-container {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 10px;\n  color: #fff;\n  background-color: #865bdf;\n  border-radius: 5px;\n  /* height: 88px; */\n  flex: 1;\n}\n\n.tooltip-content {\n  background-color: #fff;\n  color: #956fe3;\n  font-size: 12px;\n  font-weight: 600;\n  padding: 15px;\n  width: 190px;\n}\n\n.tooltip-contact {\n  border-radius: 4px;\n  background: #fff;\n  box-shadow: 1px 1px 4px 0px rgba(0, 0, 0, 0.1);\n  color: #010101;\n  font-size: 12px;\n  font-weight: 300;\n}\n\n.expand-icon {\n  width: 14px;\n  height: 14px;\n  background-size: 14px 14px;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url('../public/assets/expand_default.svg');\n}\n\n.expand-icon:hover {\n  background-image: url('../public/assets/expand_hover.svg');\n}\n\n.minimize-icon {\n  width: 14px;\n  height: 14px;\n  background-size: 14px 14px;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url('../public/assets/minimize_default.svg');\n}\n\n.minimize-icon:hover {\n  background-image: url('../public/assets/minimize_hover.svg');\n}\n\n.close-icon {\n  width: 14px;\n  height: 14px;\n  background-size: 14px 14px;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url('../public/assets/close_dialog.svg');\n}\n\n.close-icon:hover {\n  background-image: url('../public/assets/help_page_hover_close.svg');\n}\n\n.trashcan-icon {\n  width: 16px;\n  height: 16px;\n  background-size: 16px 16px;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url('../public/assets/trashcan_icon.svg');\n}\n\n.setting-option {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 7px 14px;\n}\n\n.setting-option:hover {\n  background: #f9f9f9;\n}\n\n.btn-keep {\n  width: 61px;\n  height: 30px;\n  background-size: 61px 30px;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url('../public/assets/keep_default.svg');\n}\n\n.btn-keep:hover {\n  background-image: url('../public/assets/keep_hover.svg');\n}\n\n.btn-discard {\n  display: flex;\n  height: 26px;\n  padding: 0 10px;\n  justify-content: center;\n  align-items: center;\n  border-radius: 34px;\n  border: 1px solid #dadada;\n  background: #fff;\n  cursor: pointer;\n}\n\n.btn-discard img {\n  width: 16px;\n  height: 16px;\n}\n\n.btn-discard span {\n  font-size: 12px;\n  color: #999;\n  font-weight: 400;\n}\n\n.btn-accept {\n  display: flex;\n  height: 26px;\n  padding: 0 10px;\n  justify-content: center;\n  align-items: center;\n  border-radius: 34px;\n  border: 1px solid #865bdf;\n  background: #865bdf;\n  cursor: pointer;\n}\n\n.btn-accept img {\n  width: 16px;\n  height: 16px;\n}\n\n.btn-accept span {\n  font-size: 12px;\n  color: #fff;\n  font-weight: 400;\n}\n\n@media (min-width: 768px) {\n  .btn-accept,\n  .btn-discard {\n    height: 30px;\n    padding: 0 12px;\n    border-radius: 40px;\n  }\n\n  .btn-discard img,\n  .btn-accept img {\n    width: 19px;\n    height: 19px;\n  }\n\n  .btn-discard span,\n  .btn-accept span {\n    font-size: 14px;\n  }\n}\n\n.show {\n  display: block;\n}\n\n.loader-center {\n  position: absolute;\n  z-index: 2;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.account-body {\n  display: flex;\n  height: 100vh;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.text-highlight {\n  color: #0d81d5;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.text-highlight:hover {\n  text-decoration-line: underline;\n}\n\n.btn-help-center {\n  border-radius: 4px;\n  border: 1px solid #865bdf;\n  padding: 6px 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n  color: #865bdf;\n  font-size: 14px;\n  font-weight: 400;\n  cursor: pointer;\n  margin-top: 15px;\n}\n\n.help-center-img {\n  width: 24px;\n  height: 24px;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url('../public/assets/headset_default.svg');\n}\n\n.btn-help-center:hover {\n  border: 1px solid #865bdf;\n  background: #865bdf;\n  color: #fff;\n}\n\n.btn-help-center:hover .help-center-img {\n  background-image: url('../public/assets/headset_hover.svg');\n}\n\n.required-error {\n  border: 1px solid red !important;\n  border-radius: 5px;\n  min-height: 40px !important;\n}\n\n.disabled-row {\n  background-color: #f5f5f5 !important;\n  color: #999 !important;\n  pointer-events: none; /* 禁止交互 */\n  user-select: none;\n  font-size: 14px;\n}\n\n.parent-row {\n  background-color: #f2f4ff !important;\n  border-bottom: 1px solid #fff;\n  font-size: 14px;\n}\n\n.parent-row:hover {\n  background-color: #f2f4ff !important;\n}\n\n.child-row {\n  position: relative;\n  /* z-index: 10000; */\n  background: #fbfcfe;\n}\n\n/* 适用于子项行的所有 cell */\n.k-table-row.child-row td {\n  font-size: 12px !important;\n}\n\n/* 如果里面还有 span、div 之类，也可以追加一层 */\n.k-table-row.child-row td span,\n.k-table-row.child-row td div {\n  font-size: 12px !important;\n}\n\n.k-table-row.child-row td .fontSize-10 {\n  font-size: 10px !important;\n}\n\n.k-table-row.child-row td .text-color-gray {\n  font-size: 10px !important;\n}\n\n.child-row:not(.last-child-row)::after {\n  content: '';\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: -1px;\n  height: 1px;\n  background-color: #f2f4ff;\n  z-index: -1;\n}\n\n.last-child-row {\n  position: relative;\n  /* z-index: 10000;  */\n}\n\n.last-child-row::after {\n  content: '';\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: -2px; /* 控制阴影显示到行外 */\n  height: 2px;\n  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.06);\n  background: transparent;\n  z-index: -1; /* 放在 row 背后 */\n}\n\n.orphan-row {\n  background-color: #fff !important;\n  font-size: 14px;\n}\n\n.toggle-icon img {\n  width: 16px;\n  height: 16px;\n  transition: 0.2s ease;\n}\n\n/* hover 替换图片：使用 content swap via background-image 是不行的，必须 JS 或用 attr src 替换 */\n/* 所以我们用伪类控制背景图，只改变 `src` 替代方案见下面 advanced */\n.toggle-icon[data-expanded='true']:hover img {\n  content: url('../public/assets/arrow_up_hover.svg');\n}\n\n.toggle-icon[data-expanded='false']:hover img {\n  content: url('../public/assets/collapsed_hover.svg');\n}\n\n/* 自定义整体按钮样式 */\n.custom-split-button.k-split-button {\n  height: 32px;\n  box-shadow: none;\n}\n.custom-split-button.k-button-group > .k-button:first-child:not(:only-child) {\n  border-radius: 40px 0px 0px 40px;\n  border: 1px solid #dadada;\n  background: #fff;\n  font-size: 14px;\n}\n\n.custom-split-button.k-button-group\n  > .k-button:first-child:not(:only-child):hover {\n  background: #d9d9d9;\n}\n\n.custom-split-button.k-button-group > .k-button:last-child:not(:only-child) {\n  border-radius: 0px 40px 40px 0px;\n  background: #fff;\n  border: 1px solid #dadada;\n  font-size: 14px;\n}\n\n.custom-split-button.k-button-group\n  > .k-button:last-child:not(:only-child):hover {\n  background: #d9d9d9;\n}\n\n/* 自定义分隔线颜色（按钮和下拉箭头之间） */\n.custom-split-button .k-split-button-arrow {\n  border-left: 1px solid rgba(255, 255, 255, 0.3);\n}\n\n.custom-split-button + .k-animation-container .k-popup {\n  box-shadow: none !important;\n}\n\n/* 自定义整体按钮样式 */\n.primary-split-button.k-split-button {\n  height: 32px;\n  box-shadow: none;\n}\n.primary-split-button.k-button-group > .k-button:first-child:not(:only-child) {\n  border-radius: 40px 0px 0px 40px;\n  border: none;\n  background: #333;\n  padding: 0px 12px;\n  color: #fff;\n  font-size: 14px;\n  border-right: 1px solid #fff;\n  line-height: 20px;\n}\n\n.primary-split-button.k-button-group\n  > .k-button:first-child:not(:only-child):hover {\n  background: #000000;\n}\n\n.primary-split-button.k-button-group > .k-button:last-child:not(:only-child) {\n  border-radius: 0px 40px 40px 0px;\n  background: #333;\n  border: none;\n  color: #fff;\n  font-size: 14px;\n  padding: 0 16px 0 12px;\n  border-left: 1px solid #fff;\n}\n\n.primary-split-button.k-button-group\n  > .k-button:last-child:not(:only-child):hover {\n  background: #000000;\n}\n\n/* 自定义分隔线颜色（按钮和下拉箭头之间） */\n.primary-split-button .k-split-button-arrow {\n  border-left: 1px solid #fff;\n}\n\n.primary-split-button + .k-animation-container .k-popup {\n  box-shadow: none !important;\n}\n\n.primary-split-button .k-button:disabled,\n.primary-split-button .k-button.k-disabled {\n  background: #999 !important;\n}\n\n.custom-multi-select-item {\n  background: #fff !important;\n}\n\n.custom-multi-select-item:hover {\n  background: #f2f4ff !important;\n}\n\n.k-child-animation-container .k-menu-item .k-menu-link {\n  border-radius: 4px;\n  background: #fff;\n  box-shadow: 0px 1.973px 9.867px 0px rgba(0, 0, 0, 0.2);\n  padding: 10px;\n  color: #333;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 22px; /* 157.143% */\n}\n\n.k-child-animation-container .k-menu-item .k-menu-link:hover {\n  background: #f2f4ff !important;\n}\n\n.k-child-animation-container .k-menu-item .k-menu-link {\n  border: none !important;\n  box-shadow: none !important;\n}\n\n.menu-item:hover {\n  background: #f5f5f5;\n}\n\n.client-row {\n  color: #333;\n  font-size: 14px;\n  font-weight: 600;\n  background: #f7f8fc;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  padding: 4px 8px 4px 20px;\n}\n\n.matter-row {\n  display: flex;\n  align-items: center;\n  padding: 4px 8px 4px 20px;\n  color: #595959;\n  font-size: 14px;\n  font-weight: 400;\n  cursor: pointer;\n  background: #fff;\n}\n\n.k-tooltip.custom-tooltip {\n  z-index: 200000 !important; /* 高于 window 的遮罩 */\n}\n\n.hiddenScroll {\n  scrollbar-width: none; /* Firefox */\n  -ms-overflow-style: none; /* IE 10+ */\n}\n.hiddenScroll::-webkit-scrollbar {\n  width: 0;\n  height: 0;\n}\n.hiddenScroll ::-webkit-scrollbar {\n  width: 0;\n  height: 0;\n}\n\n.mobile-timeline-scroll-container,\n.mobile-timeline-scroll-container .k-listview-content {\n  -webkit-overflow-scrolling: touch;\n  overscroll-behavior-y: contain;\n  touch-action: pan-y;\n}\n\n.fixed-child-height {\n  height: 50px;\n}\n\n.save-button {\n  display: flex;\n  padding: 5px 12px;\n  justify-content: center;\n  align-items: center;\n  gap: 4px;\n  background-color: #333;\n  text-align: center;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px; /* 142.857% */\n  color: #fff;\n  border-radius: 30px;\n  border: 1px solid #dadada;\n  cursor: pointer;\n}\n\n.save-button:hover {\n  background: #000000;\n}\n\n.cancel-button,\n.release-button {\n  display: flex;\n  padding: 5px 12px;\n  justify-content: center;\n  align-items: center;\n  gap: 4px;\n  color: #333;\n  text-align: center;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px; /* 142.857% */\n  background-color: #fff;\n  border-radius: 30px;\n  border: 1px solid #dadada;\n  cursor: pointer;\n}\n\n.cancel-button:hover,\n.release-button:hover {\n  background: #f5f5f5;\n}\n\n.confirm-button {\n  display: flex;\n  padding: 5px 12px;\n  justify-content: center;\n  align-items: center;\n  gap: 4px;\n  color: #fff;\n  text-align: center;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px; /* 142.857% */\n  border-radius: 30px;\n  cursor: pointer;\n}\n\n@media (max-width: 767px) {\n  .confirm-button {\n    padding-top: 14px;\n    padding-bottom: 14px;\n  }\n}\n\n.primary-button {\n  background-color: #333;\n  border: 1px solid #333;\n}\n\n.primary-button:hover {\n  border: 1px solid #000000;\n  background: #000000;\n}\n\n.primary-button:disabled {\n  background: #999;\n  color: #fff;\n  cursor: not-allowed;\n  border: 1px solid #999;\n}\n\n.input-error {\n  border-color: #b3261e !important;\n}\n\n.ocg-field-warning,\n.ocg-field-warning .k-input,\n.ocg-field-warning .k-input-solid {\n  background-color: #fff3e0 !important;\n  border-color: #ffa007 !important;\n}\n\n.error-text {\n  display: flex;\n  gap: 5px;\n  align-items: start;\n  color: #b3261e;\n  font-size: 14px;\n  font-weight: 400;\n  margin-top: 4px;\n}\n\n.now-button {\n  background: #fff;\n  margin-bottom: 2px;\n  padding: 2px 8px;\n  font-size: 12px;\n  font-weight: 600;\n  border-radius: 11px;\n  border: 1px solid #865bdf;\n  color: #865bdf;\n  cursor: pointer;\n}\n\n.now-button:hover {\n  border: 1px solid #865bdf;\n  background: #865bdf;\n  color: #fff;\n}\n\n.new-now-button {\n  display: flex;\n  width: 44px;\n  height: 24px;\n  padding: 0 9px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  background: #fff;\n  font-size: 12px;\n  font-weight: 400;\n  border-radius: 11px;\n  border: 1px solid #d9d9d9;\n  color: #333;\n  cursor: pointer;\n}\n\n.new-now-button:hover {\n  background: #d9d9d9;\n}\n\n.nav-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin: 0 1rem 20px;\n  padding: 20px 0 20px;\n  color: #333;\n  font-size: 14px;\n  font-weight: 400;\n}\n\n.nav-item:hover {\n  background: #eaecef;\n}\n\n.nav-item:active {\n  background: #dadbdf;\n}\n\n.k-list-item {\n  font-size: 14px;\n}\n\n.k-list-item.has-highlight {\n  display: block !important;\n  width: 100% !important;\n  max-width: 100% !important;\n  min-width: 0 !important;\n  overflow: hidden;\n  box-sizing: border-box;\n}\n\n/* Search keyword highlight */\n.highlighted-keyword {\n  font-weight: 600;\n  color: inherit;\n  background: #fde047;\n}\n\n/* 当 hover 时改变颜色 */\n/* .k-selected .highlighted-keyword,\n.k-focus .highlighted-keyword {\n  color: #ffffff!important;\n  background: inherit!important;\n} */\n\n.settings-confirm-dialog {\n  z-index: 1000001 !important;\n  top: 50% !important;\n  left: 50% !important;\n  transform: translate(-50%, -50%) !important;\n}\n\n.settings-confirm-dialog .k-window {\n  width: 480px;\n  max-width: 80vw;\n  border-radius: 20px;\n}\n\n.settings-confirm-dialog .k-window-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px; /* 按钮之间间隔可选 */\n  border-top: 1px solid #dadada;\n}\n\n.new-dialog .k-window {\n  border-radius: 12px;\n  border: none;\n}\n\n.dialog-wrapper-title {\n  font-weight: 400;\n  font-size: 20px;\n  border-bottom: 1px solid #ddd;\n  position: relative;\n  background: linear-gradient(180deg, #e4e1fc 0%, #fff 100%);\n  height: 160px;\n}\n\n@supports (-webkit-touch-callout: none) {\n  input,\n  textarea,\n  select {\n    font-size: 16px !important;\n  }\n}\n\n.group-header-btn {\n  border-radius: 40px;\n  background: #fff;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #333;\n  font-size: 14px;\n  font-weight: 400;\n  border: 1px solid #dadada;\n}\n\n.group-header-btn:hover {\n  background: #dadada;\n}\n\n.group-highlight {\n  background: #f6f0ff !important;\n  box-shadow: 0 0 0 3px #865bdf inset;\n}\n\n.dragging-highlight {\n  box-shadow: 0 0 0 3px #7fb3ff inset !important;\n  background: #eef6ff !important;\n}\n.btn-slot {\n  justify-content: center;\n  display: flex;\n  align-items: center;\n  width: 16px;\n  height: 16px;\n}\n\n.btn-slot:hover {\n  border-radius: 2px;\n  background: rgba(0, 0, 0, 0.2);\n}\n.k-time-picker-sm {\n  height: 30px;\n}\n\n.error-border {\n  border: 1px solid #e25750;\n  border-radius: 4px;\n}\n\n.editing-card {\n  box-shadow: 0 0 12px 0 rgba(255, 255, 255, 0.8) !important;\n}\n\n.grid-btn {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 0 12px;\n  height: 30px;\n  border-radius: 40px;\n  border: 1px solid #d9d9d9;\n  background: #fff;\n  color: #333;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.grid-btn:hover {\n  background-color: #f1f0f2;\n}\n\n.drag-hover-image {\n  display: none;\n}\n\n.drag-card {\n  background: #fff;\n}\n\n.drag-card:hover {\n  background: #f1f0f2;\n}\n\n.drag-card:hover .drag-hover-image {\n  display: block;\n}\n\n.btn-search-matter-check {\n  width: 16px;\n  height: 16px;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url('../public/assets/search_matter_check.svg');\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  outline: none;\n  box-shadow: none;\n}\n.btn-search-matter-check:hover {\n  background-image: url('../public/assets/search_matter_check_hover.svg');\n}\n.btn-search-matter-close {\n  width: 16px;\n  height: 16px;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url('../public/assets/search_matter_close.svg');\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  outline: none;\n  box-shadow: none;\n}\n.btn-search-matter-close:hover {\n  background-image: url('../public/assets/search_matter_close_hover.svg');\n}\n.scroll-container {\n  overflow-x: auto;\n  overflow-y: hidden;\n}\n.scroll-container::-webkit-scrollbar {\n  height: 4px;\n  width: 0px;\n}\n.scroll-container::-webkit-scrollbar-thumb {\n  background-color: #d4c8eb;\n  border-radius: 2px;\n}\n.scroll-container::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.clickable-sysnotes:hover,\n.clickable-sysnotes:active {\n  text-decoration: underline;\n}\n\n.sysnotes-popup {\n  border: none;\n  box-shadow: 0 1.973px 9.867px 0 rgba(0, 0, 0, 0.2);\n}\n\n.web-query-popup,\n.web-query-popup.k-popup,\n.k-animation-container.web-query-popup,\n.k-animation-container.web-query-popup .k-child-animation-container,\n.k-animation-container.web-query-popup .k-popup {\n  border: none;\n  background: transparent;\n  box-shadow: none;\n  border-radius: 0;\n  overflow: visible;\n  padding: 0;\n}\n\n.web-query-card {\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n  max-width: 320px;\n  max-height: 160px;\n  overflow-y: auto;\n  border-radius: 4px;\n  background: #292929;\n  padding: 8px 12px;\n  color: #fff;\n  box-shadow: 0 1.973px 9.867px 0 rgba(0, 0, 0, 0.2);\n}\n\n.web-query-card::-webkit-scrollbar {\n  width: 4px;\n}\n\n.web-query-card::-webkit-scrollbar-thumb {\n  background: #666;\n  border-radius: 100px;\n}\n\n.web-query-card .web-query-heading {\n  flex-shrink: 0;\n  position: static;\n  margin: 0;\n  background: #292929;\n  color: #fff;\n}\n\n.web-query-terms {\n  flex: none;\n  margin: 0;\n  padding-left: 16px;\n  overflow: visible;\n  list-style: disc;\n}\n\n.web-query-terms li {\n  color: #fff;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 21px;\n  overflow-wrap: anywhere;\n}\n\n.web-query-terms li::marker {\n  color: #fff;\n}\n\n.web-query-link {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  gap: 4px;\n  min-width: 0;\n  margin-bottom: 12px;\n  padding: 4px 6px;\n  overflow: hidden;\n  border: 1px solid #525252;\n  border-radius: 4px;\n  background: #333;\n  color: #fff;\n  font-size: 14px;\n  line-height: 21px;\n  text-decoration: none;\n}\n\n.web-query-link span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.web-query-link img {\n  filter: brightness(0) invert(1);\n}\n\n.web-query-link:hover span {\n  text-decoration: underline;\n}\n\n.web-query-link:last-child {\n  margin-bottom: 0;\n}\n\n.web-query-card--time {\n  max-height: 320px;\n}\n\n.web-query-narrative {\n  flex-shrink: 0;\n  margin: 0 0 8px;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 21px;\n  overflow-wrap: anywhere;\n}\n\n.sysnotes-menu-item {\n  padding: 6px 12px;\n  cursor: pointer;\n  font-size: 14px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.sysnotes-menu-item:hover {\n  background-color: #ebebeb;\n}\n\n.participants-menu-item:hover {\n  background-color: #ebebeb;\n}\n\n.clickable-sysnotes {\n  text-decoration: none;\n}\n.clickable-sysnotes:hover {\n  text-decoration: underline;\n}\n.editor-content[data-ghost-hint]::after {\n  color: #ccc;\n  content: attr(data-ghost-hint);\n  pointer-events: none;\n}\n\nh2 {\n  margin: 0;\n}\n\n.not-supported-wrapper {\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 20px;\n  flex-direction: column;\n  background: #fff;\n}\n\n.openSlot {\n  color: #333;\n  border: 1px dashed #c2c2c2;\n  background-color: #f5f5f5;\n  background-image:\n    linear-gradient(rgba(74, 68, 89, 0.08), rgba(74, 68, 89, 0.08)),\n    url('../public/assets/open-slot-stripe.png');\n  background-repeat: no-repeat, no-repeat;\n  background-position: center, center;\n  background-size: cover, cover;\n  letter-spacing: 0.25px;\n}\n\n.openSlot:hover {\n  border-color: #8c8c8c;\n}\n\n.assignedSlot {\n  background-color: #fff;\n}\n\n.assignedSlot:hover .checkbox-hidden {\n  opacity: 1 !important;\n}\n\n.assignedSlot:hover {\n  background-color: #cfe5fa;\n}\n\n.clockingActivitySlot:hover {\n  background: #cfe5fa;\n}\n\n.mobileAssignedSlot {\n  display: flex;\n  padding: 12px 0 12px 12px;\n  align-items: flex-start;\n  gap: 12px;\n  align-self: stretch;\n  overflow: hidden;\n  border-radius: 4px;\n  background: #fff;\n  box-shadow: 1px 2px 5px 0 rgba(51, 51, 51, 0.24);\n}\n\n.clockingMobileActivitySlot {\n  display: flex;\n  padding: 12px 0 12px 12px;\n  align-items: flex-start;\n  gap: 12px;\n  align-self: stretch;\n  overflow: hidden;\n  border-radius: 4px;\n}\n\n.suggestedEntry {\n  display: flex;\n  padding: 10px 0 10px 12px;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 6px;\n  align-self: stretch;\n  border-radius: 10px;\n  background: #fff;\n  position: relative;\n}\n\n.suggestedEntry:hover:not(:has(.timeEntryCard:hover)) {\n  background-color: #cfe5fa;\n}\n\n.allSelectedGroup:hover {\n  background: #cfe5fa;\n}\n\n.newGroup {\n  border-radius: 10px;\n  background: #cfe5fa;\n}\n\n.newGroup .timeEntryCard {\n  background: inherit !important;\n}\n\n.timeEntryCard {\n  position: relative;\n}\n\n.highlightedCard {\n  background: #cfe5fa;\n}\n\n.timeEntryCard:hover {\n  background: #cfe5fa;\n  border-radius: 4px;\n}\n\n.workItemEntry .timeEntryCard:hover {\n  background: #efeff0;\n}\n\n.timeEntryCard:active,\n.timeEntryCard:focus {\n  background: #fff !important;\n  border-radius: 4px;\n}\n\n.disable-hover:hover {\n  background: #fff !important;\n}\n\n/* MIRA-4344: keep Noise neutral, including matter labels and count badges.\n   Opaque backgrounds prevent underlying matter colors from showing through. */\n.noise-item {\n  background: #ebebeb !important;\n}\n.noise-item:hover {\n  background: #e0e0e0 !important;\n}\n\n.noise-item img {\n  filter: saturate(0);\n}\n\n.noise-item [data-work-item-matter-client] {\n  color: #999 !important;\n}\n\n.noise-item [data-work-item-timeslot-count] {\n  background-color: #999 !important;\n}\n\n.noise-item .checkbox-hidden,\n.noise-item .checkbox-visible,\n.noise-item:hover .checkbox-hidden,\n.noise-item:hover .checkbox-visible {\n  opacity: 0 !important;\n  pointer-events: none;\n}\n\n.noise-item .dragIconWrapper {\n  cursor: not-allowed;\n}\n\n/* Timeline drag handle: outside the card on the left, lined up with the first\n   source-icon row, shown only on hover.\n   - No top/left: an absolutely positioned flex child keeps its static\n     position, i.e. the row's start, vertically centered like the icon.\n   - The negative margin moves it left by --drag-handle-card-inset: the\n     distance from the row to the handle's right edge. It clears the card,\n     its own matter color border and a group's matter color line, with a 4px\n     gap, so the handle never sits on a line.\n   - Its containing block stays outside cards with overflow: hidden, so it is\n     not clipped. */\n.dragIconWrapper {\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  /* Suggested entry card: padding 8 + gap to the group line 12 + line 2 +\n     4px gap = 26px. */\n  margin-left: calc(-16px - var(--drag-handle-card-inset, 26px));\n  cursor: grab;\n}\n\n.dragIconWrapper .dragIcon {\n  display: flex;\n  visibility: hidden;\n}\n\n.assignedSlot:hover .dragIconWrapper .dragIcon,\n.clockingActivitySlot:hover .dragIconWrapper .dragIcon,\n.timeEntryCard:hover .dragIconWrapper .dragIcon,\n.dragIconWrapper:hover .dragIcon {\n  visibility: visible;\n}\n\n.dragIcon {\n  display: none;\n}\n\n.workItemUnassignedMarker {\n  position: absolute;\n  top: 50%;\n  left: -16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transform: translate(-50%, -50%);\n}\n\n.workItemControlRail {\n  position: absolute;\n  top: 50%;\n  left: -27px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 16px;\n  cursor: grab;\n  transform: translate(-50%, -4px);\n}\n\n.workItemControlRailDot {\n  display: flex;\n  width: 8px;\n  height: 8px;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 8px;\n}\n\n.workItemControlRail .dragIcon {\n  flex: 0 0 16px;\n  margin-top: 16px;\n}\n\n.unassignedWorkItemIndicator {\n  margin-right: 0;\n}\n\n.assignedSlot:hover .dragIcon {\n  display: block;\n}\n\n.clockingActivitySlot:hover .dragIcon {\n  display: block;\n}\n\n.dragIconWrapper:hover .dragIcon {\n  display: block;\n}\n\n.timeEntryCard:hover .dragIcon {\n  display: block;\n}\n\n.suggestedSlot {\n  background: transparent;\n  border-bottom: 1px solid #d9d9d9;\n}\n\n.suggestedSlot:hover {\n  background: #d9eafb !important;\n}\n\n.suggestedSlot:last-child {\n  border-bottom: none;\n}\n\n.inlineDurationEditor .inlineDurationInput,\n.inlineDurationEditor .inlineDurationInput .k-input,\n.inlineDurationEditor .inlineDurationInput .k-input-inner,\n.inlineDurationEditor .inlineDurationInput .k-input-spinner,\n.inlineDurationEditor .inlineDurationInput .k-input-button,\n.inlineDurationEditor .inlineDurationInput .k-button,\n.inlineDurationEditor .inlineDurationInput .k-spinner-increase,\n.inlineDurationEditor .inlineDurationInput .k-spinner-decrease {\n  background: transparent !important;\n  box-shadow: none !important;\n}\n\n.inlineDurationEditor .inlineDurationInput .k-input-inner,\n.inlineDurationEditor .inlineDurationInput input {\n  width: 30px !important;\n  min-width: 30px !important;\n  flex: 0 0 30px !important;\n  padding: 5px !important;\n}\n\n.inlineDurationEditor .inlineDurationInput .k-input-spinner {\n  display: flex !important;\n  width: 18px !important;\n  min-width: 18px !important;\n  flex: 0 0 18px !important;\n  opacity: 1 !important;\n  visibility: visible !important;\n}\n\n.inlineDurationEditor .inlineDurationInput .k-input-spinner,\n.inlineDurationEditor .inlineDurationInput .k-input-button,\n.inlineDurationEditor .inlineDurationInput .k-button {\n  border-left: 0 !important;\n}\n\n.inlineDurationEditor .inlineDurationInput .k-spinner-increase,\n.inlineDurationEditor .inlineDurationInput .k-spinner-decrease {\n  border-color: transparent !important;\n}\n\n.inlineDurationEditor--confirmation {\n  flex-direction: column;\n  align-items: stretch !important;\n  justify-content: flex-start;\n  width: 100%;\n}\n\n.inlineDurationEditor__actions {\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-end;\n  gap: 8px;\n  width: 100%;\n}\n\n.inlineDurationEditor__button {\n  box-sizing: border-box;\n  height: 30px;\n  padding: 0 12px;\n  border: 0.6px solid #d9d9d9;\n  border-radius: 999px;\n  font-family: inherit;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 1.33;\n  letter-spacing: 0.5px;\n  white-space: nowrap;\n  cursor: pointer;\n}\n\n.inlineDurationEditor__button--close {\n  min-width: 55px;\n  border-color: #fff;\n  background: transparent;\n  color: #fff;\n}\n\n.inlineDurationEditor__button--close:hover {\n  background: rgba(255, 255, 255, 0.12);\n}\n\n.inlineDurationEditor__button--save {\n  min-width: 60px;\n  background: #fff;\n  color: #333;\n}\n\n.inlineDurationEditor__button--save:hover {\n  background: linear-gradient(0deg, rgba(74, 68, 89, 0.08) 0%, rgba(74, 68, 89, 0.08) 100%), #FFF;\n}\n\n.inlineDurationEditor--inversePopup .inlineDurationInput,\n.inlineDurationEditor--inversePopup .inlineDurationInput .k-input,\n.inlineDurationEditor--inversePopup .inlineDurationInput .k-input-inner,\n.inlineDurationEditor--inversePopup .inlineDurationInput .k-input-spinner,\n.inlineDurationEditor--inversePopup .inlineDurationInput .k-input-button,\n.inlineDurationEditor--inversePopup .inlineDurationInput .k-button,\n.inlineDurationEditor--inversePopup .inlineDurationInput .k-spinner-increase,\n.inlineDurationEditor--inversePopup .inlineDurationInput .k-spinner-decrease {\n  background: #fff !important;\n  color: #333 !important;\n}\n\n.inlineDurationEditor--inversePopup .inlineDurationInput {\n  height: 28px !important;\n  border: 1px solid #d9d9d9 !important;\n  border-radius: 4px !important;\n  box-sizing: border-box !important;\n}\n\n.inlineDurationEditor--inversePopup .inlineDurationInput.k-focus,\n.inlineDurationEditor--inversePopup .inlineDurationInput:focus-within {\n  border-color: #8b3dff !important;\n}\n\n.inlineDurationEditor--inversePopup .inlineDurationInput .k-input-inner,\n.inlineDurationEditor--inversePopup .inlineDurationInput input {\n  color: #333 !important;\n  font-size: 14px !important;\n  line-height: 1.42 !important;\n}\n\n.suggestMatterOption {\n  width: max-content;\n  display: flex;\n  align-items: center;\n  border-radius: 4px;\n  box-sizing: border-box;\n  height: 32px;\n  background:\n    linear-gradient(\n      90deg,\n      rgba(134, 91, 223, 0.15) 0%,\n      rgba(60, 163, 244, 0.15) 100%\n    ),\n    #fff;\n  color: #525252;\n  overflow: hidden;\n  font-weight: 600;\n}\n\n.entryMatterOption {\n  width: max-content;\n  display: flex;\n  align-items: center;\n  border-radius: 4px;\n  box-sizing: border-box;\n  font-weight: 600;\n  cursor: pointer;\n  overflow: hidden;\n  height: 32px;\n}\n\n.leftMatterOption {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 4px 6px 6px;\n  border-radius: 4px 0 0 4px;\n}\n\n.rightMatterOption {\n  padding: 6px;\n  border-radius: 0 4px 4px 0;\n  display: flex;\n}\n\n.entryMatterOption .leftMatterOption:hover {\n  background: rgba(0, 0, 0, 0.3);\n  height: 100%;\n  border-radius: 4px 0 0 4px;\n}\n\n.entryMatterOption .rightMatterOption:hover {\n  background: rgba(0, 0, 0, 0.3);\n  height: 100%;\n  border-radius: 0 4px 4px 0;\n}\n\n.suggestMatterOption .leftMatterOption:hover {\n  color: #fff;\n  background: linear-gradient(180deg, #865bdf 0%, #6595e6 100%);\n  height: 100%;\n  border-radius: 4px 0 0 4px;\n}\n\n.suggestMatterOption .rightMatterOption:hover {\n  color: #fff;\n  background: linear-gradient(180deg, #865bdf 0%, #6595e6 100%);\n  height: 100%;\n  border-radius: 0 4px 4px 0;\n}\n\n.generateIcon {\n  width: 16px;\n  height: 16px;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url('../public/assets/common/ai_generated.svg');\n}\n\n.suggestMatterOption .leftMatterOption:hover .generateIcon {\n  background-image: url('../public/assets/common/ai_generated_white.svg');\n}\n\n.entryMatterOption .generateIcon {\n  background-image: url('../public/assets/common/ai_generated_white.svg');\n}\n\n.checkIcon {\n  width: 16px;\n  height: 16px;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url('../public/assets/common/ai_check.svg');\n}\n\n.suggestMatterOption:hover .checkIcon {\n  background-image: url('../public/assets/common/ai_check_white.svg');\n}\n\n.entryMatterOption .checkIcon {\n  background-image: url('../public/assets/common/ai_check_white.svg');\n}\n\n.closeIcon {\n  width: 16px;\n  height: 16px;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url('../public/assets/common/ai_close.svg');\n}\n\n.suggestMatterOption:hover .closeIcon {\n  background-image: url('../public/assets/common/ai_close_white.svg');\n}\n\n.extraCount {\n  background-color: #f5f5f5;\n}\n\n.extraCount:hover {\n  background-color: #e7e7e9;\n}\n\n.recent-matter-option {\n  background: #fff;\n  height: 30px;\n}\n\n.recent-matter-option:hover {\n  background: #f1f0f2;\n  border-radius: 40px;\n}\n\n.tooltipContainer div {\n  display: flex;\n}\n\n.totalHour {\n  color: #865bdf;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 133%;\n  letter-spacing: 0;\n}\n\n.totalUnit {\n  color: #865bdf;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 30px;\n  letter-spacing: 0;\n}\n\n.totalWeekHour {\n  color: #865bdf;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 133%;\n  letter-spacing: 0;\n}\n\n.totalWeekUnit {\n  color: #865bdf;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 30px;\n  letter-spacing: 0;\n}\n\n.releaseHour {\n  color: #009688;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 133%;\n  letter-spacing: 0;\n}\n\n.releaseUnit {\n  color: #009688;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 30px;\n  letter-spacing: 0;\n}\n\n.readyHour {\n  color: #2C6DDD;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 133%;\n  letter-spacing: 0;\n}\n\n.readyUnit {\n  color: #2C6DDD;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 30px;\n  letter-spacing: 0;\n}\n\n.billableHour {\n  color: #333;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 133%;\n  letter-spacing: 0;\n}\n\n.billableUnit {\n  color: #333;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 30px;\n  letter-spacing: 0;\n}\n\n.scheduleMaintenance {\n  width: calc(100% + 20px);\n  display: flex;\n  height: 56px;\n  box-sizing: border-box;\n  padding: 8px 40px 8px 20px;\n  transform: translateX(-20px);\n  justify-content: space-between;\n  align-items: center;\n  align-self: stretch;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  background-image: url('../public/assets/maintenance_bg.svg');\n  background-size: cover;\n}\n\n.floatingMergeBtn {\n  width: 46px;\n  height: 46px;\n  display: inline-flex;\n  padding: 8px;\n  border: none;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  border-radius: 16px;\n  background: #4a4459;\n  box-shadow:\n    0 1px 2px 0 rgba(0, 0, 0, 0.3),\n    0 1px 3px 1px rgba(0, 0, 0, 0.15);\n}\n\n.floatingMergeDisabledBtn {\n  width: 46px;\n  height: 46px;\n  display: inline-flex;\n  padding: 8px;\n  border: none;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  border-radius: 16px;\n  background: #999;\n  box-shadow:\n    0 1px 2px 0 rgba(0, 0, 0, 0.3),\n    0 1px 3px 1px rgba(0, 0, 0, 0.15);\n}\n\n.floatingMergeBtn:hover {\n  background: #332d41;\n}\n\n.floatingMergeDisabledBtn:hover {\n  background: #757575;\n}\n\n.checkbox-hidden {\n  opacity: 0;\n  /* pointer-events: none;  */\n  transition: opacity 0.15s ease;\n}\n\n.checkbox-visible {\n  opacity: 1;\n  /* pointer-events: auto; */\n  transition: opacity 0.15s ease;\n}\n\n.common-radio {\n  width: 14px;\n  height: 14px;\n  accent-color: #865bdf;\n  margin: 0;\n}\n\n.tooltip-btn {\n  display: inline-flex;\n  height: 30px;\n  padding: 0 12px;\n  justify-content: center;\n  align-items: center;\n  gap: 4px;\n  border-radius: 999px;\n  border: 1px solid #fff;\n  width: fit-content;\n}\n\n.tooltip-btn:hover {\n  background: rgba(255, 255, 255, 0.12);\n}\n\n.combo-error.k-combobox {\n  border: 1px solid #b3261e !important;\n}\n\n.clockingDisabled {\n  /* background: #F7F7F8;\n    color: #9E9E9E;\n    cursor: default; */\n}\n\n.clockingDisabled:hover {\n  /* background: #F7F7F8; */\n}\n\n.clockingDisabled img {\n  opacity: 0.65;\n}\n\n.clockingDisabled .dragIcon img,\n.clockingDisabled canvas,\n.clockingGroupDragIcon .dragIcon img {\n  opacity: 1;\n}\n\n.clockingDisabled .k-tooltip,\n.clockingDisabled .k-tooltip *,\n.clockingGroupDragIcon .k-tooltip,\n.clockingGroupDragIcon .k-tooltip * {\n  color: #fff !important;\n  opacity: 1;\n}\n\n/* Two-dot button loader (DotsLoader): the dots pulse in turn. */\n.dots-loader {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  flex-shrink: 0;\n}\n\n.dots-loader > span {\n  display: block;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: currentColor;\n  animation: dots-loader-pulse 0.9s ease-in-out infinite;\n}\n\n.dots-loader > span:nth-child(2) {\n  animation-delay: -0.45s;\n}\n\n@keyframes dots-loader-pulse {\n  0%,\n  100% {\n    transform: scale(0.6);\n  }\n  50% {\n    transform: scale(1);\n  }\n}\n\n\n@property --move-border-angle {\n  syntax: '<angle>';\n  initial-value: 0deg;\n  inherits: false;\n}\n\n.time-entry-move-highlight {\n  position: relative;\n}\n\n.time-entry-move-highlight::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  z-index: 1101;\n  border-radius: 6px;\n  padding: 2px;\n  background: conic-gradient(from var(--move-border-angle), #865BDF, #4285F4, #34A853, #FBBC05, #EA4335, #865BDF);\n  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);\n  -webkit-mask-composite: xor;\n  mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);\n  mask-composite: exclude;\n  pointer-events: none;\n  animation: time-entry-move-border 3s linear both;\n}\n\n@keyframes time-entry-move-border {\n  0% { --move-border-angle: 0deg; opacity: 1; }\n  85% { opacity: 1; }\n  100% { --move-border-angle: 360deg; opacity: 0; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .time-entry-move-highlight::after {\n    animation-name: time-entry-move-border-static;\n  }\n}\n\n@keyframes time-entry-move-border-static {\n  0%, 85% { opacity: 1; }\n  100% { opacity: 0; }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
